import Disclaimer from "../components/Disclaimer";
import GamblingCare from '../assets/GamblingCare-w-300x39.png'
import Navigation from "../components/Navigation";
import bet247 from '../assets/bet247.png'
import betitonLogo from '../assets/betiton.png'
import betvictor from '../assets/betvictor.svg'
import boylecasino from '../assets/boylecasino.svg'
import coral from '../assets/coral.svg'
import dueiz from '../assets/dueiz.png'
import livescorebet from '../assets/livescorebet.svg'
import lottoland from '../assets/lottoland.png'
import midniteLogo from '../assets/midnite.png'
import talksportbet from '../assets/talksport.svg'
import tonybet from '../assets/tonybet.png'
import { usePageTitle } from "../hooks/usePageTitle";

const HomePage = () => {
  usePageTitle();

  return (
    <div id="body" className="home page-template page-template-template-casino page page-id-272 wp-embed-responsive geo-az bid-60">
      <div
        className="background_image background-wrapper hidden md:block absolute w-full z-[10] md:bg-[url(&#039;images/ireland-bg.png&#039;)] bg-[right_top] sm:bg-[right_top] md:bg-[center_top] bg-no-repeat bg-[length:100%_auto] sm:bg-auto">
      </div>
      <div
        className="background_image background-wrapper block md:hidden absolute w-full z-[10] bg-[url(&#039;images/ireland-mobile-pot-of-gold.png&#039;)] mt-[50px] md:mt-[100px] md:bg-none bg-[right_top] sm:bg-[right_top] md:bg-[center_top] bg-no-repeat bg-[length:100%_auto] sm:bg-auto">         
      </div>
      <Disclaimer />
      <Navigation />
      <main>
        <div className=" absolute z-1 w-full" style={{ background: "linear-gradient(1deg, #0d0d14, black)" }}>
        </div>
        <div className="container flex flex-col gap relative z-10 headline-theme-1">
          <b className="md:hidden font-[700] text-[18px] md:text-[32px]">February 2026</b>
          <h1 className="font-[700] text-[24px] md:text-[32px] m-0 mb-[8px] w-[290px] sm:w-full">Best Irish Online Casino
            Sites <b className="md:inline hidden text-[20px] md:text-[32px]">February 2026</b></h1>
          <p className="text-[18px] font-[400] sm:w-[620px] md:w-full sm:block hidden">The best online casino sites in
            Ireland can be found here. Each brand has been reviewed and ranked based on its most noteworthy
            features. Compare them below to find the one that’s right for you.</p>
        </div>

        <main className="container flex flex-col sm:!py-[32px] relative z-10 gc-color-1">
          <div className="lineup-contaner flex-[1_0] min-w-0 flex flex-col gap-[24px] md:pb-[0px] shadow-[0_0_14px_7px_black] bg-black mt-[16px]"
            id="primary-list" data-list-id="1751">
            <article
              data-skeleton-loading="true"
              className="llineup-item flex relative z-[1] flex-wrap mt-[8px] rounded-2xl primary-order"
              data-id="737" data-brand_id="113943" data-pid="685473" data-name="Midnite" data-badge="false">
              <div className="ppc-list__item_logo relative rounded-tl-[16px] py-[16px] px-[18px] flex flex-col justify-center w-[40%] bg-[#1c1f33] md:w-[20%] md:rounded-bl-[16px]
    md:items-center">
                <a className="brand-name-logo-link" rel="noreferrer" target="_blank" data-skeleton="true"
                  href="https://out.casinonlineireland.site/track/click/?pid=685473&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=1&amp;action=dl-logo">
                  <img src={midniteLogo}
                    alt="Midnite" fetchpriority="high" data-logo
                    className="lozad max-h-[65px] w-[180px] max-w-full block mx-auto mt-[8px]"
                    data-loaded="true" />
                </a>
                <div className="md:hidden text-center">
                  <a className="rating flex flex-col mt-[10px] items-center md:mt-0"
                    target="_blank"
                    rel="noreferrer"
                    href="https://out.casinonlineireland.site/track/click/?pid=685473&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=1&amp;action=dl-score">
                    <div className="score betting text-white font-poppins text-[32px] font-semibold md:leading-7 md:mb-[6px]"
                      data-skeleton="true">
                      9.9
                    </div>
                    <div className="score-stars brand-stars-wrapper" data-skeleton="true">
                      <ul className="star-row betting" data-default="5">
                        <li><i className="stars"></i></li>
                        <li><i className="stars"></i></li>
                        <li><i className="stars"></i></li>
                        <li><i className="stars"></i></li>
                        <li><i className="stars"></i></li>
                      </ul>
                    </div>
                  </a>
                </div>
              </div>
              <div
                className="ppc-list__item_info w-[60%] rounded-tr-[16px] bg-[#2f334e] text-center py-[16px] px-[9px] md:w-[80%] flex justify-center md:flex-col md:px-0 md:pb-0 md:rounded-br-[16px]">
                <div
                  className="flex flex-col md:flex-row md:pb-[16px] md:px-[32px] md:pl-[45px] justify-center md:justify-between md:items-center">
                  <div className="bonus-text-wrapper md:relative md:w-[224px]">
                    <a className="bonus-text-wrapper"
                      href="https://out.casinonlineireland.site/track/click/?pid=685473&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=1&amp;action=dl-bonus"
                      rel="noreferrer" target="_blank" title="">
                      <div className="text-center text-white text-[15px] sm:text-[18px] font-medium leading-[24px] sm:max-w-[330px] md:w-full"
                        data-skeleton="true">
                        <p>Bet €20, Get<br />
                          100 Free Spins</p>

                      </div>
                    </a>
                  </div>
                  <div className="hidden md:block h-full w-[1px] bg-[#1c1f33]"></div>
                  <div className="brd hidden md:relative md:block md:w-[110px]">
                    <a className="rating flex flex-col mt-[10px] items-center md:mt-0"
                      target="_blank"
                      rel="noreferrer"
                      href="https://out.casinonlineireland.site/track/click/?pid=685473&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=1&amp;action=dl-score">
                      <div className="score betting text-white font-poppins text-[32px] font-semibold md:leading-7 md:mb-[6px]"
                        data-skeleton="true">
                        9.9
                      </div>
                      <div className="score-stars brand-stars-wrapper" data-skeleton="true">
                        <ul className="star-row betting" data-default="5">
                          <li><i className="stars"></i></li>
                          <li><i className="stars"></i></li>
                          <li><i className="stars"></i></li>
                          <li><i className="stars"></i></li>
                          <li><i className="stars"></i></li>
                        </ul>
                      </div>
                    </a>
                  </div>
                  <div className="hidden md:block h-full w-[1px] bg-[#1c1f33]"></div>

                  <div className="mt-[12px] md:mt-0 md:relative flex flex-col items-center">
                    <a className="bonus-btn-wrapper hover:brightness-[1.15] active:brightness-[0.91] w-[160px] md:w-[168px] inline-block py-[4.5px] px-[15px] md:py-[6.5px] h-[40px] md:h-[44px] rounded-[10px]"
                      href="https://out.casinonlineireland.site/track/click/?pid=685473&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=1&amp;action=dl-btn"
                      rel="noreferrer" target="_blank" title="" data-skeleton="true">
                      <span
                        className="bonus-button font-poppins text-white font-extrabold uppercase text-[18px] inline-block relative leading-8">
                        Get Bonus
                      </span>
                    </a>
                    <a className="visit-site !text-[#63BCFF] hover:!text-[#A5D8FF] text-[14px] relative md:inline-block mt-[16px] font-poppins"
                      href="https://out.casinonlineireland.site/track/click/?pid=685473&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=1&amp;action=dl-textlink"
                      rel="noreferrer" target="_blank" data-skeleton="true" title="Midnite">
                      Visit Site
                    </a>
                  </div>
                </div>
                <div className="hidden md:block" data-skeleton="true">
                  <div
                    className="legaltext__block bottom-part w-[100%] bg-[#262a40] z-[1] relative rounded-br-[16px] rounded-bl-[16px] md:rounded-bl-none">
                    <a className="rounded-br-[16px] rounded-bl-[16px] legaltext__overlay absolute -z-[1] left-0 right-0 bottom-0 top-0 text-[#FFF] bg-[#262a40]"
                      target="_blank"
                      rel="noreferrer"
                      href="https://out.casinonlineireland.site/track/click/?pid=685473&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=1&amp;action=dl-legal">
                    </a>
                    <div
                      className="legaltext__inner legal-text pointer-events-none relative z-[1] text-[#FFF] text-center flex justify-center pt-[13px] pb-[3px] px-[13px]">
                      <p className="leading-[10px]">
                        <sup className="text-[9px] leading-[13.5px] text-white" id="legal-text-content"
                          data-full-text="">New customers only. Opt in and wager €20 or more on
                          selected games within 14 days of registration. Get 100 Free Spins for
                          selected games, valued at 10 cents and valid for 7 days. T&Cs apply.
                          GambleAware.org</sup>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="md:hidden w-full" data-skeleton="true">
                <div
                  className="legaltext__block bottom-part w-[100%] bg-[#262a40] z-[1] relative rounded-br-[16px] rounded-bl-[16px] md:rounded-bl-none">
                  <a className="rounded-br-[16px] rounded-bl-[16px] legaltext__overlay absolute -z-[1] left-0 right-0 bottom-0 top-0 text-[#FFF] bg-[#262a40]"
                    target="_blank"
                    rel="noreferrer"
                    href="https://out.casinonlineireland.site/track/click/?pid=685473&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=1&amp;action=dl-legal">
                  </a>
                  <div
                    className="legaltext__inner legal-text pointer-events-none relative z-[1] text-[#FFF] text-center flex justify-center pt-[13px] pb-[3px] px-[13px]">
                    <p className="leading-[10px]">
                      <sup className="text-[9px] leading-[13.5px] text-white" id="legal-text-content"
                        data-full-text="">New customers only. Opt in and wager €20 or more on selected
                        games within 14 days of registration. Get 100 Free Spins for selected games,
                        valued at 10 cents and valid for 7 days. T&Cs apply. GambleAware.org</sup>
                    </p>
                  </div>
                </div>
              </div>
            </article>
            <article className="lineup-item flex relative z-[1] flex-wrap mt-[8px] rounded-2xl secondary-order"
              data-skeleton-loading="true"
              data-id="444" data-brand_id="108675" data-pid="679932" data-name="betiton casino"
              data-badge="false">
              <div className="ppc-list__item_logo relative rounded-tl-[16px] py-[16px] px-[18px] flex flex-col justify-center w-[40%] bg-[#1c1f33] md:w-[20%] md:rounded-bl-[16px]
    md:items-center">
                <a className="brand-name-logo-link" rel="noreferrer" target="_blank" data-skeleton="true"
                  href=" https://out.casinonlineireland.site/track/click/?pid=679932&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=2&amp;action=dl-logo">
                  <img src={betitonLogo}
                    alt="betiton casino" fetchpriority="high" data-logo
                    className="lozad max-h-[65px] w-[180px] max-w-full block mx-auto mt-[8px]"
                    data-loaded="true" />
                </a>
                <div className="md:hidden text-center">
                  <a className="rating flex flex-col mt-[10px] items-center md:mt-0"
                    target="_blank"
                    rel="noreferrer"
                    href=" https://out.casinonlineireland.site/track/click/?pid=679932&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=2&amp;action=dl-score">
                    <div className="score betting text-white font-poppins text-[32px] font-semibold md:leading-7 md:mb-[6px]"
                      data-skeleton="true">
                      9.8
                    </div>
                    <div className="score-stars brand-stars-wrapper" data-skeleton="true">
                      <ul className="star-row betting" data-default="5">
                        <li><i className="stars"></i></li>
                        <li><i className="stars"></i></li>
                        <li><i className="stars"></i></li>
                        <li><i className="stars"></i></li>
                        <li><i className="stars"></i></li>
                      </ul>
                    </div>
                  </a>
                </div>
              </div>
              <div
                className="ppc-list__item_info w-[60%] rounded-tr-[16px] bg-[#2f334e] text-center py-[16px] px-[9px] md:w-[80%] flex justify-center md:flex-col md:px-0 md:pb-0 md:rounded-br-[16px]">
                <div
                  className="flex flex-col md:flex-row md:pb-[16px] md:px-[32px] md:pl-[45px] justify-center md:justify-between md:items-center">
                  <div className="bonus-text-wrapper md:relative md:w-[224px]">
                    <a className="bonus-text-wrapper"
                      href=" https://out.casinonlineireland.site/track/click/?pid=679932&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=2&amp;action=dl-bonus"
                      rel="noreferrer" target="_blank" title="">
                      <div className="text-center text-white text-[15px] sm:text-[18px] font-medium leading-[24px] sm:max-w-[330px] md:w-full"
                        data-skeleton="true">
                        <p>100% Up To €500 + 150 Free Spins</p>

                      </div>
                    </a>
                  </div>
                  <div className="hidden md:block h-full w-[1px] bg-[#1c1f33]"></div>
                  <div className="brd hidden md:relative md:block md:w-[110px]">
                    <a className="rating flex flex-col mt-[10px] items-center md:mt-0"
                      target="_blank"
                      rel="noreferrer"
                      href=" https://out.casinonlineireland.site/track/click/?pid=679932&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=2&amp;action=dl-score">
                      <div className="score betting text-white font-poppins text-[32px] font-semibold md:leading-7 md:mb-[6px]"
                        data-skeleton="true">
                        9.8
                      </div>
                      <div className="score-stars brand-stars-wrapper" data-skeleton="true">
                        <ul className="star-row betting" data-default="5">
                          <li><i className="stars"></i></li>
                          <li><i className="stars"></i></li>
                          <li><i className="stars"></i></li>
                          <li><i className="stars"></i></li>
                          <li><i className="stars"></i></li>
                        </ul>
                      </div>
                    </a>
                  </div>
                  <div className="hidden md:block h-full w-[1px] bg-[#1c1f33]"></div>

                  <div className="mt-[12px] md:mt-0 md:relative flex flex-col items-center">
                    <a className="bonus-btn-wrapper hover:brightness-[1.15] active:brightness-[0.91] w-[160px] md:w-[168px] inline-block py-[4.5px] px-[15px] md:py-[6.5px] h-[40px] md:h-[44px] rounded-[10px]"
                      href=" https://out.casinonlineireland.site/track/click/?pid=679932&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=2&amp;action=dl-btn"
                      rel="noreferrer" target="_blank" title="" data-skeleton="true">
                      <span
                        className="bonus-button font-poppins text-white font-extrabold uppercase text-[18px] inline-block relative leading-8">
                        Get Bonus
                      </span>
                    </a>
                    <a className="visit-site !text-[#63BCFF] hover:!text-[#A5D8FF] text-[14px] relative md:inline-block mt-[16px] font-poppins"
                      href=" https://out.casinonlineireland.site/track/click/?pid=679932&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=2&amp;action=dl-textlink"
                      rel="noreferrer" target="_blank" data-skeleton="true" title="betiton">
                      Visit Site
                    </a>
                  </div>
                </div>
                <div className="hidden md:block" data-skeleton="true">
                  <div
                    className="legaltext__block bottom-part w-[100%] bg-[#262a40] z-[1] relative rounded-br-[16px] rounded-bl-[16px] md:rounded-bl-none">
                    <a className="rounded-br-[16px] rounded-bl-[16px] legaltext__overlay absolute -z-[1] left-0 right-0 bottom-0 top-0 text-[#FFF] bg-[#262a40]"
                      target="_blank"
                      rel="noreferrer"
                      href=" https://out.casinonlineireland.site/track/click/?pid=679932&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=2&amp;action=dl-legal">
                    </a>
                    <div
                      className="legaltext__inner legal-text pointer-events-none relative z-[1] text-[#FFF] text-center flex justify-center pt-[13px] pb-[3px] px-[13px]">
                      <p className="leading-[10px]">
                        <sup className="text-[9px] leading-[13.5px] text-white" id="legal-text-content"
                          data-full-text="">New Customers Only. 18+.Wagering requirements and T&C's
                          Apply</sup>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="md:hidden w-full" data-skeleton="true">
                <div
                  className="legaltext__block bottom-part w-[100%] bg-[#262a40] z-[1] relative rounded-br-[16px] rounded-bl-[16px] md:rounded-bl-none">
                  <a className="rounded-br-[16px] rounded-bl-[16px] legaltext__overlay absolute -z-[1] left-0 right-0 bottom-0 top-0 text-[#FFF] bg-[#262a40]"
                    target="_blank"
                    rel="noreferrer"
                    href=" https://out.casinonlineireland.site/track/click/?pid=679932&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=2&amp;action=dl-legal">
                  </a>
                  <div
                    className="legaltext__inner legal-text pointer-events-none relative z-[1] text-[#FFF] text-center flex justify-center pt-[13px] pb-[3px] px-[13px]">
                    <p className="leading-[10px]">
                      <sup className="text-[9px] leading-[13.5px] text-white" id="legal-text-content"
                        data-full-text="">New Customers Only. 18+.Wagering requirements and T&C's
                        Apply</sup>
                    </p>
                  </div>
                </div>
              </div>
            </article>
            <article className="lineup-item flex relative z-[1] flex-wrap mt-[8px] rounded-2xl secondary-order"
              data-skeleton-loading="true"
              data-id="761" data-brand_id="113982" data-pid="685527" data-name="Betvictor casino"
              data-badge="false">
              <div className="ppc-list__item_logo relative rounded-tl-[16px] py-[16px] px-[18px] flex flex-col justify-center w-[40%] bg-[#1c1f33] md:w-[20%] md:rounded-bl-[16px]
    md:items-center">
                <a className="brand-name-logo-link" rel="noreferrer" target="_blank" data-skeleton="true"
                  href="https://out.casinonlineireland.site/track/click/?pid=685527&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=3&amp;action=dl-logo">
                  <img src={betvictor}
                    alt="Betvictor casino" loading="lazy" data-logo
                    className="lozad max-h-[65px] w-[180px] max-w-full block mx-auto mt-[8px]"
                    data-loaded="true" />
                </a>
                <div className="md:hidden text-center">
                  <a className="rating flex flex-col mt-[10px] items-center md:mt-0"
                    target="_blank"
                    rel="noreferrer"
                    href="https://out.casinonlineireland.site/track/click/?pid=685527&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=3&amp;action=dl-score">
                    <div className="score betting text-white font-poppins text-[32px] font-semibold md:leading-7 md:mb-[6px]"
                      data-skeleton="true">
                      9.7
                    </div>
                    <div className="score-stars brand-stars-wrapper" data-skeleton="true">
                      <ul className="star-row betting" data-default="5">
                        <li><i className="stars"></i></li>
                        <li><i className="stars"></i></li>
                        <li><i className="stars"></i></li>
                        <li><i className="stars"></i></li>
                        <li><i className="stars"></i></li>
                      </ul>
                    </div>
                  </a>
                </div>
              </div>
              <div
                className="ppc-list__item_info w-[60%] rounded-tr-[16px] bg-[#2f334e] text-center py-[16px] px-[9px] md:w-[80%] flex justify-center md:flex-col md:px-0 md:pb-0 md:rounded-br-[16px]">
                <div
                  className="flex flex-col md:flex-row md:pb-[16px] md:px-[32px] md:pl-[45px] justify-center md:justify-between md:items-center">
                  <div className="bonus-text-wrapper md:relative md:w-[224px]">
                    <a className="bonus-text-wrapper"
                      href="https://out.casinonlineireland.site/track/click/?pid=685527&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=3&amp;action=dl-bonus"
                      rel="noreferrer" target="_blank" title="">
                      <div className="text-center text-white text-[15px] sm:text-[18px] font-medium leading-[24px] sm:max-w-[330px] md:w-full"
                        data-skeleton="true">
                        <p>Wager €10, Get €50<br />
                          + 100 Free Spins</p>

                      </div>
                    </a>
                  </div>
                  <div className="hidden md:block h-full w-[1px] bg-[#1c1f33]"></div>
                  <div className="brd hidden md:relative md:block md:w-[110px]">
                    <a className="rating flex flex-col mt-[10px] items-center md:mt-0"
                      target="_blank"
                      rel="noreferrer"
                      href="https://out.casinonlineireland.site/track/click/?pid=685527&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=3&amp;action=dl-score">
                      <div className="score betting text-white font-poppins text-[32px] font-semibold md:leading-7 md:mb-[6px]"
                        data-skeleton="true">
                        9.7
                      </div>
                      <div className="score-stars brand-stars-wrapper" data-skeleton="true">
                        <ul className="star-row betting" data-default="5">
                          <li><i className="stars"></i></li>
                          <li><i className="stars"></i></li>
                          <li><i className="stars"></i></li>
                          <li><i className="stars"></i></li>
                          <li><i className="stars"></i></li>
                        </ul>
                      </div>
                    </a>
                  </div>
                  <div className="hidden md:block h-full w-[1px] bg-[#1c1f33]"></div>

                  <div className="mt-[12px] md:mt-0 md:relative flex flex-col items-center">
                    <a className="bonus-btn-wrapper hover:brightness-[1.15] active:brightness-[0.91] w-[160px] md:w-[168px] inline-block py-[4.5px] px-[15px] md:py-[6.5px] h-[40px] md:h-[44px] rounded-[10px]"
                      href="https://out.casinonlineireland.site/track/click/?pid=685527&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=3&amp;action=dl-btn"
                      rel="noreferrer" target="_blank" title="" data-skeleton="true">
                      <span
                        className="bonus-button font-poppins text-white font-extrabold uppercase text-[18px] inline-block relative leading-8">
                        Get Bonus
                      </span>
                    </a>
                    <a className="visit-site !text-[#63BCFF] hover:!text-[#A5D8FF] text-[14px] relative md:inline-block mt-[16px] font-poppins"
                      href="https://out.casinonlineireland.site/track/click/?pid=685527&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=3&amp;action=dl-textlink"
                      rel="noreferrer" target="_blank" data-skeleton="true" title="Betvictor ">
                      Visit Site
                    </a>
                  </div>
                </div>
                <div className="hidden md:block" data-skeleton="true">
                  <div
                    className="legaltext__block bottom-part w-[100%] bg-[#262a40] z-[1] relative rounded-br-[16px] rounded-bl-[16px] md:rounded-bl-none">
                    <a className="rounded-br-[16px] rounded-bl-[16px] legaltext__overlay absolute -z-[1] left-0 right-0 bottom-0 top-0 text-[#FFF] bg-[#262a40]"
                      target="_blank"
                      rel="noreferrer"
                      href="https://out.casinonlineireland.site/track/click/?pid=685527&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=3&amp;action=dl-legal">
                    </a>
                    <div
                      className="legaltext__inner legal-text pointer-events-none relative z-[1] text-[#FFF] text-center flex justify-center pt-[13px] pb-[3px] px-[13px]">
                      <p className="leading-[10px]">
                        <sup className="text-[9px] leading-[13.5px] text-white" id="legal-text-content"
                          data-full-text="">New Customers Only. 18+.Wagering requirements and T&C's
                          Apply</sup>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="md:hidden w-full" data-skeleton="true">
                <div
                  className="legaltext__block bottom-part w-[100%] bg-[#262a40] z-[1] relative rounded-br-[16px] rounded-bl-[16px] md:rounded-bl-none">
                  <a className="rounded-br-[16px] rounded-bl-[16px] legaltext__overlay absolute -z-[1] left-0 right-0 bottom-0 top-0 text-[#FFF] bg-[#262a40]"
                    target="_blank"
                    rel="noreferrer"
                    href="https://out.casinonlineireland.site/track/click/?pid=685527&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=3&amp;action=dl-legal">
                  </a>
                  <div
                    className="legaltext__inner legal-text pointer-events-none relative z-[1] text-[#FFF] text-center flex justify-center pt-[13px] pb-[3px] px-[13px]">
                    <p className="leading-[10px]">
                      <sup className="text-[9px] leading-[13.5px] text-white" id="legal-text-content"
                        data-full-text="">New Customers Only. 18+.Wagering requirements and T&C's
                        Apply</sup>
                    </p>
                  </div>
                </div>
              </div>
            </article>
            <article className="lineup-item flex relative z-[1] flex-wrap mt-[8px] rounded-2xl secondary-order"
              data-skeleton-loading="true"

              data-id="371" data-brand_id="112983" data-pid="683505" data-name="Boyle" data-badge="false">
              <div className="ppc-list__item_logo relative rounded-tl-[16px] py-[16px] px-[18px] flex flex-col justify-center w-[40%] bg-[#1c1f33] md:w-[20%] md:rounded-bl-[16px]
    md:items-center">
                <a className="brand-name-logo-link" rel="noreferrer" target="_blank" data-skeleton="true"
                  href="https://out.casinonlineireland.site/track/click/?pid=683505&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=4&amp;action=dl-logo">
                  <img src={boylecasino}
                    alt="Boyle" loading="lazy" data-logo
                    className="lozad max-h-[65px] w-[180px] max-w-full block mx-auto mt-[8px]"
                    data-loaded="true" />
                </a>
                <div className="md:hidden text-center">
                  <a className="rating flex flex-col mt-[10px] items-center md:mt-0" 
                    target="_blank"
                    rel="noreferrer"
                    href="https://out.casinonlineireland.site/track/click/?pid=683505&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=4&amp;action=dl-score">
                    <div className="score betting text-white font-poppins text-[32px] font-semibold md:leading-7 md:mb-[6px]"
                      data-skeleton="true">
                      9.5
                    </div>
                    <div className="score-stars brand-stars-wrapper" data-skeleton="true">
                      <ul className="star-row betting" data-default="4.5">
                        <li><i className="stars"></i></li>
                        <li><i className="stars"></i></li>
                        <li><i className="stars"></i></li>
                        <li><i className="stars"></i></li>
                        <li><i className="stars"></i></li>
                      </ul>
                    </div>
                  </a>
                </div>
              </div>
              <div
                className="ppc-list__item_info w-[60%] rounded-tr-[16px] bg-[#2f334e] text-center py-[16px] px-[9px] md:w-[80%] flex justify-center md:flex-col md:px-0 md:pb-0 md:rounded-br-[16px]">
                <div
                  className="flex flex-col md:flex-row md:pb-[16px] md:px-[32px] md:pl-[45px] justify-center md:justify-between md:items-center">
                  <div className="bonus-text-wrapper md:relative md:w-[224px]">
                    <a className="bonus-text-wrapper"
                      href="https://out.casinonlineireland.site/track/click/?pid=683505&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=4&amp;action=dl-bonus"
                      rel="noreferrer" target="_blank" title="">
                      <div className="text-center text-white text-[15px] sm:text-[18px] font-medium leading-[24px] sm:max-w-[330px] md:w-full"
                        data-skeleton="true">
                        <p style={{ textAlign: 'center' }}>Get €50 Casino Bonus</p>

                      </div>
                    </a>
                  </div>
                  <div className="hidden md:block h-full w-[1px] bg-[#1c1f33]"></div>
                  <div className="brd hidden md:relative md:block md:w-[110px]">
                    <a className="rating flex flex-col mt-[10px] items-center md:mt-0"
                      target="_blank"
                      rel="noreferrer"
                      href="https://out.casinonlineireland.site/track/click/?pid=683505&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=4&amp;action=dl-score">
                      <div className="score betting text-white font-poppins text-[32px] font-semibold md:leading-7 md:mb-[6px]"
                        data-skeleton="true">
                        9.5
                      </div>
                      <div className="score-stars brand-stars-wrapper" data-skeleton="true">
                        <ul className="star-row betting" data-default="4.5">
                          <li><i className="stars"></i></li>
                          <li><i className="stars"></i></li>
                          <li><i className="stars"></i></li>
                          <li><i className="stars"></i></li>
                          <li><i className="stars"></i></li>
                        </ul>
                      </div>
                    </a>
                  </div>
                  <div className="hidden md:block h-full w-[1px] bg-[#1c1f33]"></div>

                  <div className="mt-[12px] md:mt-0 md:relative flex flex-col items-center">
                    <a className="bonus-btn-wrapper hover:brightness-[1.15] active:brightness-[0.91] w-[160px] md:w-[168px] inline-block py-[4.5px] px-[15px] md:py-[6.5px] h-[40px] md:h-[44px] rounded-[10px]"
                      href="https://out.casinonlineireland.site/track/click/?pid=683505&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=4&amp;action=dl-btn"
                      rel="noreferrer" target="_blank" title="" data-skeleton="true">
                      <span
                        className="bonus-button font-poppins text-white font-extrabold uppercase text-[18px] inline-block relative leading-8">
                        Get Bonus
                      </span>
                    </a>
                    <a className="visit-site !text-[#63BCFF] hover:!text-[#A5D8FF] text-[14px] relative md:inline-block mt-[16px] font-poppins"
                      href="https://out.casinonlineireland.site/track/click/?pid=683505&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=4&amp;action=dl-textlink"
                      rel="noreferrer" target="_blank" data-skeleton="true" title="Boyle">
                      Visit Site
                    </a>
                  </div>
                </div>
                <div className="hidden md:block" data-skeleton="true">
                  <div
                    className="legaltext__block bottom-part w-[100%] bg-[#262a40] z-[1] relative rounded-br-[16px] rounded-bl-[16px] md:rounded-bl-none">
                    <a className="rounded-br-[16px] rounded-bl-[16px] legaltext__overlay absolute -z-[1] left-0 right-0 bottom-0 top-0 text-[#FFF] bg-[#262a40]"
                      target="_blank"
                      rel="noreferrer"
                      href="https://out.casinonlineireland.site/track/click/?pid=683505&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=4&amp;action=dl-legal">
                    </a>
                    <div
                      className="legaltext__inner legal-text pointer-events-none relative z-[1] text-[#FFF] text-center flex justify-center pt-[13px] pb-[3px] px-[13px]">
                      <p className="leading-[10px]">
                        <sup className="text-[9px] leading-[13.5px] text-white" id="legal-text-content"
                          data-full-text="">18+. Opt in. Acc/Game/Payment restrictions apply. B10G50:
                          Exp. 12.01.26. New UK/ROI gaming players. Excl. other Casino welcome offers.
                          Min. cash wag. £/€10(cumulative) within 48hrs. 168 hrs to accept & use
                          Bonus. Max. redeem. £/€500. 40x wag. Cash balance used until wag. req.
                          complete. once per player. Snow Run: Ends 26.12.25. Once daily. Free Spin
                          (FS) value £/€0.10. Offer accepted by 23:59 same day. 24 hrs/play FS. Accept
                          free-to-play prize to enter the draws. 1 prize/player/draw, 5 draws total.
                          Min £/€10 dep & stake per draw. 1 entry per €/£10 staked. T&Cs Apply</sup>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="md:hidden w-full" data-skeleton="true">
                <div
                  className="legaltext__block bottom-part w-[100%] bg-[#262a40] z-[1] relative rounded-br-[16px] rounded-bl-[16px] md:rounded-bl-none">
                  <a className="rounded-br-[16px] rounded-bl-[16px] legaltext__overlay absolute -z-[1] left-0 right-0 bottom-0 top-0 text-[#FFF] bg-[#262a40]"
                    target="_blank"
                    rel="noreferrer"
                    href="https://out.casinonlineireland.site/track/click/?pid=683505&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=4&amp;action=dl-legal">
                  </a>
                  <div
                    className="legaltext__inner legal-text pointer-events-none relative z-[1] text-[#FFF] text-center flex justify-center pt-[13px] pb-[3px] px-[13px]">
                    <p className="leading-[10px]">
                      <sup className="text-[9px] leading-[13.5px] text-white" id="legal-text-content"
                        data-full-text="">18+. Opt in. Acc/Game/Payment restrictions apply. B10G50: Exp.
                        12.01.26. New UK/ROI gaming players. Excl. other Casino welcome offers. Min.
                        cash wag. £/€10(cumulative) within 48hrs. 168 hrs to accept & use Bonus. Max.
                        redeem. £/€500. 40x wag. Cash balance used until wag. req. complete. once per
                        player. Snow Run: Ends 26.12.25. Once daily. Free Spin (FS) value £/€0.10. Offer
                        accepted by 23:59 same day. 24 hrs/play FS. Accept free-to-play prize to enter
                        the draws. 1 prize/player/draw, 5 draws total. Min £/€10 dep & stake per draw. 1
                        entry per €/£10 staked. T&Cs Apply</sup>
                    </p>
                  </div>
                </div>
              </div>
            </article>
            <article className="lineup-item flex relative z-[1] flex-wrap mt-[8px] rounded-2xl secondary-order"
              data-skeleton-loading="true"

              data-id="735" data-brand_id="113946" data-pid="685476" data-name="247bet" data-badge="false">
              <div className="ppc-list__item_logo relative rounded-tl-[16px] py-[16px] px-[18px] flex flex-col justify-center w-[40%] bg-[#1c1f33] md:w-[20%] md:rounded-bl-[16px]
    md:items-center">
                <a className="brand-name-logo-link" rel="noreferrer" target="_blank" data-skeleton="true"
                  href="https://out.casinonlineireland.site/track/click/?pid=685476&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=5&amp;action=dl-logo">
                  <img src={bet247}
                    alt="247bet" loading="lazy" data-logo
                    className="lozad max-h-[65px] w-[180px] max-w-full block mx-auto mt-[8px]"
                    data-loaded="true" />
                </a>
                <div className="md:hidden text-center">
                  <a className="rating flex flex-col mt-[10px] items-center md:mt-0"
                    target="_blank"
                    rel="noreferrer"
                    href="https://out.casinonlineireland.site/track/click/?pid=685476&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=5&amp;action=dl-score">
                    <div className="score betting text-white font-poppins text-[32px] font-semibold md:leading-7 md:mb-[6px]"
                      data-skeleton="true">
                      9.4
                    </div>
                    <div className="score-stars brand-stars-wrapper" data-skeleton="true">
                      <ul className="star-row betting" data-default="4.5">
                        <li><i className="stars"></i></li>
                        <li><i className="stars"></i></li>
                        <li><i className="stars"></i></li>
                        <li><i className="stars"></i></li>
                        <li><i className="stars"></i></li>
                      </ul>
                    </div>
                  </a>
                </div>
              </div>
              <div
                className="ppc-list__item_info w-[60%] rounded-tr-[16px] bg-[#2f334e] text-center py-[16px] px-[9px] md:w-[80%] flex justify-center md:flex-col md:px-0 md:pb-0 md:rounded-br-[16px]">
                <div
                  className="flex flex-col md:flex-row md:pb-[16px] md:px-[32px] md:pl-[45px] justify-center md:justify-between md:items-center">
                  <div className="bonus-text-wrapper md:relative md:w-[224px]">
                    <a className="bonus-text-wrapper"
                      href="https://out.casinonlineireland.site/track/click/?pid=685476&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=5&amp;action=dl-bonus"
                      rel="noreferrer" target="_blank" title="">
                      <div className="text-center text-white text-[15px] sm:text-[18px] font-medium leading-[24px] sm:max-w-[330px] md:w-full"
                        data-skeleton="true">
                        <p>100% Up To €247<br />
                          + 100 Free Spins</p>

                      </div>
                    </a>
                  </div>
                  <div className="hidden md:block h-full w-[1px] bg-[#1c1f33]"></div>
                  <div className="brd hidden md:relative md:block md:w-[110px]">
                    <a className="rating flex flex-col mt-[10px] items-center md:mt-0"
                      target="_blank"
                      rel="noreferrer"
                      href="https://out.casinonlineireland.site/track/click/?pid=685476&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=5&amp;action=dl-score">
                      <div className="score betting text-white font-poppins text-[32px] font-semibold md:leading-7 md:mb-[6px]"
                        data-skeleton="true">
                        9.4
                      </div>
                      <div className="score-stars brand-stars-wrapper" data-skeleton="true">
                        <ul className="star-row betting" data-default="4.5">
                          <li><i className="stars"></i></li>
                          <li><i className="stars"></i></li>
                          <li><i className="stars"></i></li>
                          <li><i className="stars"></i></li>
                          <li><i className="stars"></i></li>
                        </ul>
                      </div>
                    </a>
                  </div>
                  <div className="hidden md:block h-full w-[1px] bg-[#1c1f33]"></div>

                  <div className="mt-[12px] md:mt-0 md:relative flex flex-col items-center">
                    <a className="bonus-btn-wrapper hover:brightness-[1.15] active:brightness-[0.91] w-[160px] md:w-[168px] inline-block py-[4.5px] px-[15px] md:py-[6.5px] h-[40px] md:h-[44px] rounded-[10px]"
                      href="https://out.casinonlineireland.site/track/click/?pid=685476&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=5&amp;action=dl-btn"
                      rel="noreferrer" target="_blank" title="" data-skeleton="true">
                      <span
                        className="bonus-button font-poppins text-white font-extrabold uppercase text-[18px] inline-block relative leading-8">
                        Get Bonus
                      </span>
                    </a>
                    <a className="visit-site !text-[#63BCFF] hover:!text-[#A5D8FF] text-[14px] relative md:inline-block mt-[16px] font-poppins"
                      href="https://out.casinonlineireland.site/track/click/?pid=685476&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=5&amp;action=dl-textlink"
                      rel="noreferrer" target="_blank" data-skeleton="true" title="247bet">
                      Visit Site
                    </a>
                  </div>
                </div>
                <div className="hidden md:block" data-skeleton="true">
                  <div
                    className="legaltext__block bottom-part w-[100%] bg-[#262a40] z-[1] relative rounded-br-[16px] rounded-bl-[16px] md:rounded-bl-none">
                    <a className="rounded-br-[16px] rounded-bl-[16px] legaltext__overlay absolute -z-[1] left-0 right-0 bottom-0 top-0 text-[#FFF] bg-[#262a40]"
                      target="_blank"
                      rel="noreferrer"
                      href="https://out.casinonlineireland.site/track/click/?pid=685476&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=5&amp;action=dl-legal">
                    </a>
                    <div
                      className="legaltext__inner legal-text pointer-events-none relative z-[1] text-[#FFF] text-center flex justify-center pt-[13px] pb-[3px] px-[13px]">
                      <p className="leading-[10px]">
                        <sup className="text-[9px] leading-[13.5px] text-white" id="legal-text-content"
                          data-full-text="">New Customers Only. 18+.Wagering requirements and T&C's
                          Apply</sup>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="md:hidden w-full" data-skeleton="true">
                <div
                  className="legaltext__block bottom-part w-[100%] bg-[#262a40] z-[1] relative rounded-br-[16px] rounded-bl-[16px] md:rounded-bl-none">
                  <a className="rounded-br-[16px] rounded-bl-[16px] legaltext__overlay absolute -z-[1] left-0 right-0 bottom-0 top-0 text-[#FFF] bg-[#262a40]"
                    target="_blank"
                    rel="noreferrer"
                    href="https://out.casinonlineireland.site/track/click/?pid=685476&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=5&amp;action=dl-legal">
                  </a>
                  <div
                    className="legaltext__inner legal-text pointer-events-none relative z-[1] text-[#FFF] text-center flex justify-center pt-[13px] pb-[3px] px-[13px]">
                    <p className="leading-[10px]">
                      <sup className="text-[9px] leading-[13.5px] text-white" id="legal-text-content"
                        data-full-text="">New Customers Only. 18+.Wagering requirements and T&C's
                        Apply</sup>
                    </p>
                  </div>
                </div>
              </div>
            </article>
            <article className="lineup-item flex relative z-[1] flex-wrap mt-[8px] rounded-2xl secondary-order"
              data-skeleton-loading="true"

              data-id="718" data-brand_id="113937" data-pid="685467" data-name="Duelz Casino" data-badge="false">
              <div className="ppc-list__item_logo relative rounded-tl-[16px] py-[16px] px-[18px] flex flex-col justify-center w-[40%] bg-[#1c1f33] md:w-[20%] md:rounded-bl-[16px]
    md:items-center">
                <a className="brand-name-logo-link" rel="noreferrer" target="_blank" data-skeleton="true"
                  href="https://out.casinonlineireland.site/track/click/?pid=685467&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=6&amp;action=dl-logo">
                  <img src={dueiz}
                    alt="Duelz Casino" loading="lazy" data-logo
                    className="lozad max-h-[65px] w-[180px] max-w-full block mx-auto mt-[8px]"
                    data-loaded="true" />
                </a>
                <div className="md:hidden text-center">
                  <a className="rating flex flex-col mt-[10px] items-center md:mt-0"
                    target="_blank"
                    rel="noreferrer"
                    href="https://out.casinonlineireland.site/track/click/?pid=685467&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=6&amp;action=dl-score">
                    <div className="score betting text-white font-poppins text-[32px] font-semibold md:leading-7 md:mb-[6px]"
                      data-skeleton="true">
                      9.3
                    </div>
                    <div className="score-stars brand-stars-wrapper" data-skeleton="true">
                      <ul className="star-row betting" data-default="4.5">
                        <li><i className="stars"></i></li>
                        <li><i className="stars"></i></li>
                        <li><i className="stars"></i></li>
                        <li><i className="stars"></i></li>
                        <li><i className="stars"></i></li>
                      </ul>
                    </div>
                  </a>
                </div>
              </div>
              <div
                className="ppc-list__item_info w-[60%] rounded-tr-[16px] bg-[#2f334e] text-center py-[16px] px-[9px] md:w-[80%] flex justify-center md:flex-col md:px-0 md:pb-0 md:rounded-br-[16px]">
                <div
                  className="flex flex-col md:flex-row md:pb-[16px] md:px-[32px] md:pl-[45px] justify-center md:justify-between md:items-center">
                  <div className="bonus-text-wrapper md:relative md:w-[224px]">
                    <a className="bonus-text-wrapper"
                      href="https://out.casinonlineireland.site/track/click/?pid=685467&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=6&amp;action=dl-bonus"
                      rel="noreferrer" target="_blank" title="">
                      <div className="text-center text-white text-[15px] sm:text-[18px] font-medium leading-[24px] sm:max-w-[330px] md:w-full"
                        data-skeleton="true">
                        <p>€100 Bonus<br />
                          + 200 Free Spins</p>

                      </div>
                    </a>
                  </div>
                  <div className="hidden md:block h-full w-[1px] bg-[#1c1f33]"></div>
                  <div className="brd hidden md:relative md:block md:w-[110px]">
                    <a className="rating flex flex-col mt-[10px] items-center md:mt-0"
                      target="_blank"
                      rel="noreferrer"
                      href="https://out.casinonlineireland.site/track/click/?pid=685467&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=6&amp;action=dl-score">
                      <div className="score betting text-white font-poppins text-[32px] font-semibold md:leading-7 md:mb-[6px]"
                        data-skeleton="true">
                        9.3
                      </div>
                      <div className="score-stars brand-stars-wrapper" data-skeleton="true">
                        <ul className="star-row betting" data-default="4.5">
                          <li><i className="stars"></i></li>
                          <li><i className="stars"></i></li>
                          <li><i className="stars"></i></li>
                          <li><i className="stars"></i></li>
                          <li><i className="stars"></i></li>
                        </ul>
                      </div>
                    </a>
                  </div>
                  <div className="hidden md:block h-full w-[1px] bg-[#1c1f33]"></div>

                  <div className="mt-[12px] md:mt-0 md:relative flex flex-col items-center">
                    <a className="bonus-btn-wrapper hover:brightness-[1.15] active:brightness-[0.91] w-[160px] md:w-[168px] inline-block py-[4.5px] px-[15px] md:py-[6.5px] h-[40px] md:h-[44px] rounded-[10px]"
                      href="https://out.casinonlineireland.site/track/click/?pid=685467&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=6&amp;action=dl-btn"
                      rel="noreferrer" target="_blank" title="" data-skeleton="true">
                      <span
                        className="bonus-button font-poppins text-white font-extrabold uppercase text-[18px] inline-block relative leading-8">
                        Get Bonus
                      </span>
                    </a>
                    <a className="visit-site !text-[#63BCFF] hover:!text-[#A5D8FF] text-[14px] relative md:inline-block mt-[16px] font-poppins"
                      href="https://out.casinonlineireland.site/track/click/?pid=685467&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=6&amp;action=dl-textlink"
                      rel="noreferrer" target="_blank" data-skeleton="true" title="Duelz Casino">
                      Visit Site
                    </a>
                  </div>
                </div>
                <div className="hidden md:block" data-skeleton="true">
                  <div
                    className="legaltext__block bottom-part w-[100%] bg-[#262a40] z-[1] relative rounded-br-[16px] rounded-bl-[16px] md:rounded-bl-none">
                    <a className="rounded-br-[16px] rounded-bl-[16px] legaltext__overlay absolute -z-[1] left-0 right-0 bottom-0 top-0 text-[#FFF] bg-[#262a40]"
                      target="_blank"
                      rel="noreferrer"
                      href="https://out.casinonlineireland.site/track/click/?pid=685467&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=6&amp;action=dl-legal">
                    </a>
                    <div
                      className="legaltext__inner legal-text pointer-events-none relative z-[1] text-[#FFF] text-center flex justify-center pt-[13px] pb-[3px] px-[13px]">
                      <p className="leading-[10px]">
                        <sup className="text-[9px] leading-[13.5px] text-white" id="legal-text-content"
                          data-full-text="">18+. New Customers only. SuprPlay Limited.
                          MGA/B2C/325/2016. Min deposit: €20. Wagering req.: 30x (deposit + bonus).
                          Play responsibly. www.rgf.org.mt T&C Apply</sup>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="md:hidden w-full" data-skeleton="true">
                <div
                  className="legaltext__block bottom-part w-[100%] bg-[#262a40] z-[1] relative rounded-br-[16px] rounded-bl-[16px] md:rounded-bl-none">
                  <a className="rounded-br-[16px] rounded-bl-[16px] legaltext__overlay absolute -z-[1] left-0 right-0 bottom-0 top-0 text-[#FFF] bg-[#262a40]"
                    target="_blank"
                    rel="noreferrer"
                    href="https://out.casinonlineireland.site/track/click/?pid=685467&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=6&amp;action=dl-legal">
                  </a>
                  <div
                    className="legaltext__inner legal-text pointer-events-none relative z-[1] text-[#FFF] text-center flex justify-center pt-[13px] pb-[3px] px-[13px]">
                    <p className="leading-[10px]">
                      <sup className="text-[9px] leading-[13.5px] text-white" id="legal-text-content"
                        data-full-text="">18+. New Customers only. SuprPlay Limited. MGA/B2C/325/2016.
                        Min deposit: €20. Wagering req.: 30x (deposit + bonus). Play responsibly.
                        www.rgf.org.mt T&C Apply</sup>
                    </p>
                  </div>
                </div>
              </div>
            </article>
            <article className="lineup-item flex relative z-[1] flex-wrap mt-[8px] rounded-2xl secondary-order"
              data-skeleton-loading="true"

              data-id="745" data-brand_id="108612" data-pid="679836" data-name="Livescore Bet" data-badge="false">
              <div className="ppc-list__item_logo relative rounded-tl-[16px] py-[16px] px-[18px] flex flex-col justify-center w-[40%] bg-[#1c1f33] md:w-[20%] md:rounded-bl-[16px]
    md:items-center">
                <a className="brand-name-logo-link" rel="noreferrer" target="_blank" data-skeleton="true"
                  href="https://out.casinonlineireland.site/track/click/?pid=679836&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=7&amp;action=dl-logo">
                  <img src={livescorebet}
                    alt="Livescore Bet" loading="lazy" data-logo
                    className="lozad max-h-[65px] w-[180px] max-w-full block mx-auto mt-[8px]"
                    data-loaded="true" />
                </a>
                <div className="md:hidden text-center">
                  <a className="rating flex flex-col mt-[10px] items-center md:mt-0"
                    target="_blank"
                    rel="noreferrer"
                    href="https://out.casinonlineireland.site/track/click/?pid=679836&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=7&amp;action=dl-score">
                    <div className="score betting text-white font-poppins text-[32px] font-semibold md:leading-7 md:mb-[6px]"
                      data-skeleton="true">
                      9.1
                    </div>
                    <div className="score-stars brand-stars-wrapper" data-skeleton="true">
                      <ul className="star-row betting" data-default="4.5">
                        <li><i className="stars"></i></li>
                        <li><i className="stars"></i></li>
                        <li><i className="stars"></i></li>
                        <li><i className="stars"></i></li>
                        <li><i className="stars"></i></li>
                      </ul>
                    </div>
                  </a>
                </div>
              </div>
              <div
                className="ppc-list__item_info w-[60%] rounded-tr-[16px] bg-[#2f334e] text-center py-[16px] px-[9px] md:w-[80%] flex justify-center md:flex-col md:px-0 md:pb-0 md:rounded-br-[16px]">
                <div
                  className="flex flex-col md:flex-row md:pb-[16px] md:px-[32px] md:pl-[45px] justify-center md:justify-between md:items-center">
                  <div className="bonus-text-wrapper md:relative md:w-[224px]">
                    <a className="bonus-text-wrapper"
                      href="https://out.casinonlineireland.site/track/click/?pid=679836&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=7&amp;action=dl-bonus"
                      rel="noreferrer" target="_blank" title="">
                      <div className="text-center text-white text-[15px] sm:text-[18px] font-medium leading-[24px] sm:max-w-[330px] md:w-full"
                        data-skeleton="true">
                        <p style={{ textAlign: 'center' }}>Play €10, Get<br />
                          300 Free Spins</p>

                      </div>
                    </a>
                  </div>
                  <div className="hidden md:block h-full w-[1px] bg-[#1c1f33]"></div>
                  <div className="brd hidden md:relative md:block md:w-[110px]">
                    <a className="rating flex flex-col mt-[10px] items-center md:mt-0"
                      target="_blank"
                      rel="noreferrer"
                      href="https://out.casinonlineireland.site/track/click/?pid=679836&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=7&amp;action=dl-score">
                      <div className="score betting text-white font-poppins text-[32px] font-semibold md:leading-7 md:mb-[6px]"
                        data-skeleton="true">
                        9.1
                      </div>
                      <div className="score-stars brand-stars-wrapper" data-skeleton="true">
                        <ul className="star-row betting" data-default="4.5">
                          <li><i className="stars"></i></li>
                          <li><i className="stars"></i></li>
                          <li><i className="stars"></i></li>
                          <li><i className="stars"></i></li>
                          <li><i className="stars"></i></li>
                        </ul>
                      </div>
                    </a>
                  </div>
                  <div className="hidden md:block h-full w-[1px] bg-[#1c1f33]"></div>

                  <div className="mt-[12px] md:mt-0 md:relative flex flex-col items-center">
                    <a className="bonus-btn-wrapper hover:brightness-[1.15] active:brightness-[0.91] w-[160px] md:w-[168px] inline-block py-[4.5px] px-[15px] md:py-[6.5px] h-[40px] md:h-[44px] rounded-[10px]"
                      href="https://out.casinonlineireland.site/track/click/?pid=679836&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=7&amp;action=dl-btn"
                      rel="noreferrer" target="_blank" title="" data-skeleton="true">
                      <span
                        className="bonus-button font-poppins text-white font-extrabold uppercase text-[18px] inline-block relative leading-8">
                        Get Bonus
                      </span>
                    </a>
                    <a className="visit-site !text-[#63BCFF] hover:!text-[#A5D8FF] text-[14px] relative md:inline-block mt-[16px] font-poppins"
                      href="https://out.casinonlineireland.site/track/click/?pid=679836&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=7&amp;action=dl-textlink"
                      rel="noreferrer" target="_blank" data-skeleton="true" title="Livescore Bet">
                      Visit Site
                    </a>
                  </div>
                </div>
                <div className="hidden md:block" data-skeleton="true">
                  <div
                    className="legaltext__block bottom-part w-[100%] bg-[#262a40] z-[1] relative rounded-br-[16px] rounded-bl-[16px] md:rounded-bl-none">
                    <a className="rounded-br-[16px] rounded-bl-[16px] legaltext__overlay absolute -z-[1] left-0 right-0 bottom-0 top-0 text-[#FFF] bg-[#262a40]"
                      target="_blank"
                      rel="noreferrer"
                      href="https://out.casinonlineireland.site/track/click/?pid=679836&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=7&amp;action=dl-legal">
                    </a>
                    <div
                      className="legaltext__inner legal-text pointer-events-none relative z-[1] text-[#FFF] text-center flex justify-center pt-[13px] pb-[3px] px-[13px]">
                      <p className="leading-[10px]">
                        <sup className="text-[9px] leading-[13.5px] text-white" id="legal-text-content"
                          data-full-text="">New LiveScore Bet members only. Must sign up via ad offer
                          link. Cash wager within 7 days of reg. Free Spins: Accept via pop-up the day
                          you qualify; use on Big Bass Bonanza (10c spin value, valid 3 days). T&Cs
                          and deposit exclusions apply.Bet Responsibly. Gamblingcare.ie. 18+.</sup>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="md:hidden w-full" data-skeleton="true">
                <div
                  className="legaltext__block bottom-part w-[100%] bg-[#262a40] z-[1] relative rounded-br-[16px] rounded-bl-[16px] md:rounded-bl-none">
                  <a className="rounded-br-[16px] rounded-bl-[16px] legaltext__overlay absolute -z-[1] left-0 right-0 bottom-0 top-0 text-[#FFF] bg-[#262a40]"
                    target="_blank"
                    rel="noreferrer"
                    href="https://out.casinonlineireland.site/track/click/?pid=679836&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=7&amp;action=dl-legal">
                  </a>
                  <div
                    className="legaltext__inner legal-text pointer-events-none relative z-[1] text-[#FFF] text-center flex justify-center pt-[13px] pb-[3px] px-[13px]">
                    <p className="leading-[10px]">
                      <sup className="text-[9px] leading-[13.5px] text-white" id="legal-text-content"
                        data-full-text="">New LiveScore Bet members only. Must sign up via ad offer
                        link. Cash wager within 7 days of reg. Free Spins: Accept via pop-up the day you
                        qualify; use on Big Bass Bonanza (10c spin value, valid 3 days). T&Cs and
                        deposit exclusions apply.Bet Responsibly. Gamblingcare.ie. 18+.</sup>
                    </p>
                  </div>
                </div>
              </div>
            </article>
            <article className="lineup-item flex relative z-[1] flex-wrap mt-[8px] rounded-2xl secondary-order"
              data-skeleton-loading="true"

              data-id="599" data-brand_id="113688" data-pid="684657" data-name="Coral" data-badge="false">
              <div className="ppc-list__item_logo relative rounded-tl-[16px] py-[16px] px-[18px] flex flex-col justify-center w-[40%] bg-[#1c1f33] md:w-[20%] md:rounded-bl-[16px]
    md:items-center">
                <a className="brand-name-logo-link" rel="noreferrer" target="_blank" data-skeleton="true"
                  href="https://out.casinonlineireland.site/track/click/?pid=684657&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=8&amp;action=dl-logo">
                  <img src={coral}
                    alt="Coral" loading="lazy" data-logo
                    className="lozad max-h-[65px] w-[180px] max-w-full block mx-auto mt-[8px]"
                    data-loaded="true" />
                </a>
                <div className="md:hidden text-center">
                  <a className="rating flex flex-col mt-[10px] items-center md:mt-0"
                    target="_blank"
                    rel="noreferrer"
                    href="https://out.casinonlineireland.site/track/click/?pid=684657&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=8&amp;action=dl-score">
                    <div className="score betting text-white font-poppins text-[32px] font-semibold md:leading-7 md:mb-[6px]"
                      data-skeleton="true">
                      8.8
                    </div>
                    <div className="score-stars brand-stars-wrapper" data-skeleton="true">
                      <ul className="star-row betting" data-default="4">
                        <li><i className="stars"></i></li>
                        <li><i className="stars"></i></li>
                        <li><i className="stars"></i></li>
                        <li><i className="stars"></i></li>
                        <li><i className="stars"></i></li>
                      </ul>
                    </div>
                  </a>
                </div>
              </div>
              <div
                className="ppc-list__item_info w-[60%] rounded-tr-[16px] bg-[#2f334e] text-center py-[16px] px-[9px] md:w-[80%] flex justify-center md:flex-col md:px-0 md:pb-0 md:rounded-br-[16px]">
                <div
                  className="flex flex-col md:flex-row md:pb-[16px] md:px-[32px] md:pl-[45px] justify-center md:justify-between md:items-center">
                  <div className="bonus-text-wrapper md:relative md:w-[224px]">
                    <a className="bonus-text-wrapper"
                      href="https://out.casinonlineireland.site/track/click/?pid=684657&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=8&amp;action=dl-bonus"
                      rel="noreferrer" target="_blank" title="">
                      <div className="text-center text-white text-[15px] sm:text-[18px] font-medium leading-[24px] sm:max-w-[330px] md:w-full"
                        data-skeleton="true">
                        <p>Play €10 Get 100 Free Spins</p>

                      </div>
                    </a>
                  </div>
                  <div className="hidden md:block h-full w-[1px] bg-[#1c1f33]"></div>
                  <div className="brd hidden md:relative md:block md:w-[110px]">
                    <a className="rating flex flex-col mt-[10px] items-center md:mt-0"
                      target="_blank"
                      rel="noreferrer"
                      href="https://out.casinonlineireland.site/track/click/?pid=684657&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=8&amp;action=dl-score">
                      <div className="score betting text-white font-poppins text-[32px] font-semibold md:leading-7 md:mb-[6px]"
                        data-skeleton="true">
                        8.8
                      </div>
                      <div className="score-stars brand-stars-wrapper" data-skeleton="true">
                        <ul className="star-row betting" data-default="4">
                          <li><i className="stars"></i></li>
                          <li><i className="stars"></i></li>
                          <li><i className="stars"></i></li>
                          <li><i className="stars"></i></li>
                          <li><i className="stars"></i></li>
                        </ul>
                      </div>
                    </a>
                  </div>
                  <div className="hidden md:block h-full w-[1px] bg-[#1c1f33]"></div>

                  <div className="mt-[12px] md:mt-0 md:relative flex flex-col items-center">
                    <a className="bonus-btn-wrapper hover:brightness-[1.15] active:brightness-[0.91] w-[160px] md:w-[168px] inline-block py-[4.5px] px-[15px] md:py-[6.5px] h-[40px] md:h-[44px] rounded-[10px]"
                      href="https://out.casinonlineireland.site/track/click/?pid=684657&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=8&amp;action=dl-btn"
                      rel="noreferrer" target="_blank" title="" data-skeleton="true">
                      <span
                        className="bonus-button font-poppins text-white font-extrabold uppercase text-[18px] inline-block relative leading-8">
                        Get Bonus
                      </span>
                    </a>
                    <a className="visit-site !text-[#63BCFF] hover:!text-[#A5D8FF] text-[14px] relative md:inline-block mt-[16px] font-poppins"
                      href="https://out.casinonlineireland.site/track/click/?pid=684657&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=8&amp;action=dl-textlink"
                      rel="noreferrer" target="_blank" data-skeleton="true" title="Coral">
                      Visit Site
                    </a>
                  </div>
                </div>
                <div className="hidden md:block" data-skeleton="true">
                  <div
                    className="legaltext__block bottom-part w-[100%] bg-[#262a40] z-[1] relative rounded-br-[16px] rounded-bl-[16px] md:rounded-bl-none">
                    <a className="rounded-br-[16px] rounded-bl-[16px] legaltext__overlay absolute -z-[1] left-0 right-0 bottom-0 top-0 text-[#FFF] bg-[#262a40]"
                      target="_blank"
                      rel="noreferrer"
                      href="https://out.casinonlineireland.site/track/click/?pid=684657&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=8&amp;action=dl-legal">
                    </a>
                    <div
                      className="legaltext__inner legal-text pointer-events-none relative z-[1] text-[#FFF] text-center flex justify-center pt-[13px] pb-[3px] px-[13px]">
                      <p className="leading-[10px]">
                        <sup className="text-[9px] leading-[13.5px] text-white" id="legal-text-content"
                          data-full-text="">18+. New Casino players only. Deposit (certain types
                          excluded) and Bet €10+ on Slots games to get 100 Free Spins (selected games,
                          value €0.10 each, 48 hrs to accept, valid for 7 days). Restrictions and T&Cs
                          apply.</sup>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="md:hidden w-full" data-skeleton="true">
                <div
                  className="legaltext__block bottom-part w-[100%] bg-[#262a40] z-[1] relative rounded-br-[16px] rounded-bl-[16px] md:rounded-bl-none">
                  <a className="rounded-br-[16px] rounded-bl-[16px] legaltext__overlay absolute -z-[1] left-0 right-0 bottom-0 top-0 text-[#FFF] bg-[#262a40]"
                    target="_blank"
                    rel="noreferrer"
                    href="https://out.casinonlineireland.site/track/click/?pid=684657&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=8&amp;action=dl-legal">
                  </a>
                  <div
                    className="legaltext__inner legal-text pointer-events-none relative z-[1] text-[#FFF] text-center flex justify-center pt-[13px] pb-[3px] px-[13px]">
                    <p className="leading-[10px]">
                      <sup className="text-[9px] leading-[13.5px] text-white" id="legal-text-content"
                        data-full-text="">18+. New Casino players only. Deposit (certain types excluded)
                        and Bet €10+ on Slots games to get 100 Free Spins (selected games, value €0.10
                        each, 48 hrs to accept, valid for 7 days). Restrictions and T&Cs apply.</sup>
                    </p>
                  </div>
                </div>
              </div>
            </article>
            <article className="lineup-item flex relative z-[1] flex-wrap mt-[8px] rounded-2xl secondary-order"
              data-skeleton-loading="true"

              data-id="740" data-brand_id="113940" data-pid="685470" data-name="TalkSport" data-badge="false">
              <div className="ppc-list__item_logo relative rounded-tl-[16px] py-[16px] px-[18px] flex flex-col justify-center w-[40%] bg-[#1c1f33] md:w-[20%] md:rounded-bl-[16px]
    md:items-center">
                <a className="brand-name-logo-link" rel="noreferrer" target="_blank" data-skeleton="true"
                  href="https://out.casinonlineireland.site/track/click/?pid=685470&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=9&amp;action=dl-logo">
                  <img src={talksportbet}
                    alt="TalkSport" loading="lazy" data-logo
                    className="lozad max-h-[65px] w-[180px] max-w-full block mx-auto mt-[8px]"
                    data-loaded="true" />
                </a>
                <div className="md:hidden text-center">
                  <a className="rating flex flex-col mt-[10px] items-center md:mt-0"
                    target="_blank"
                    rel="noreferrer"
                    href="https://out.casinonlineireland.site/track/click/?pid=685470&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=9&amp;action=dl-score">
                    <div className="score betting text-white font-poppins text-[32px] font-semibold md:leading-7 md:mb-[6px]"
                      data-skeleton="true">
                      8.7
                    </div>
                    <div className="score-stars brand-stars-wrapper" data-skeleton="true">
                      <ul className="star-row betting" data-default="4">
                        <li><i className="stars"></i></li>
                        <li><i className="stars"></i></li>
                        <li><i className="stars"></i></li>
                        <li><i className="stars"></i></li>
                        <li><i className="stars"></i></li>
                      </ul>
                    </div>
                  </a>
                </div>
              </div>
              <div
                className="ppc-list__item_info w-[60%] rounded-tr-[16px] bg-[#2f334e] text-center py-[16px] px-[9px] md:w-[80%] flex justify-center md:flex-col md:px-0 md:pb-0 md:rounded-br-[16px]">
                <div
                  className="flex flex-col md:flex-row md:pb-[16px] md:px-[32px] md:pl-[45px] justify-center md:justify-between md:items-center">
                  <div className="bonus-text-wrapper md:relative md:w-[224px]">
                    <a className="bonus-text-wrapper"
                      href="https://out.casinonlineireland.site/track/click/?pid=685470&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=9&amp;action=dl-bonus"
                      rel="noreferrer" target="_blank" title="">
                      <div className="text-center text-white text-[15px] sm:text-[18px] font-medium leading-[24px] sm:max-w-[330px] md:w-full"
                        data-skeleton="true">
                        <p>Get €50 In Bonuses<br />
                          + 50 Free Spins</p>

                      </div>
                    </a>
                  </div>
                  <div className="hidden md:block h-full w-[1px] bg-[#1c1f33]"></div>
                  <div className="brd hidden md:relative md:block md:w-[110px]">
                    <a className="rating flex flex-col mt-[10px] items-center md:mt-0"
                      target="_blank"
                      rel="noreferrer"
                      href="https://out.casinonlineireland.site/track/click/?pid=685470&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=9&amp;action=dl-score">
                      <div className="score betting text-white font-poppins text-[32px] font-semibold md:leading-7 md:mb-[6px]"
                        data-skeleton="true">
                        8.7
                      </div>
                      <div className="score-stars brand-stars-wrapper" data-skeleton="true">
                        <ul className="star-row betting" data-default="4">
                          <li><i className="stars"></i></li>
                          <li><i className="stars"></i></li>
                          <li><i className="stars"></i></li>
                          <li><i className="stars"></i></li>
                          <li><i className="stars"></i></li>
                        </ul>
                      </div>
                    </a>
                  </div>
                  <div className="hidden md:block h-full w-[1px] bg-[#1c1f33]"></div>

                  <div className="mt-[12px] md:mt-0 md:relative flex flex-col items-center">
                    <a className="bonus-btn-wrapper hover:brightness-[1.15] active:brightness-[0.91] w-[160px] md:w-[168px] inline-block py-[4.5px] px-[15px] md:py-[6.5px] h-[40px] md:h-[44px] rounded-[10px]"
                      href="https://out.casinonlineireland.site/track/click/?pid=685470&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=9&amp;action=dl-btn"
                      rel="noreferrer" target="_blank" title="" data-skeleton="true">
                      <span
                        className="bonus-button font-poppins text-white font-extrabold uppercase text-[18px] inline-block relative leading-8">
                        Get Bonus
                      </span>
                    </a>
                    <a className="visit-site !text-[#63BCFF] hover:!text-[#A5D8FF] text-[14px] relative md:inline-block mt-[16px] font-poppins"
                      href="https://out.casinonlineireland.site/track/click/?pid=685470&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=9&amp;action=dl-textlink"
                      rel="noreferrer" target="_blank" data-skeleton="true" title="TalkSport">
                      Visit Site
                    </a>
                  </div>
                </div>
                <div className="hidden md:block" data-skeleton="true">
                  <div
                    className="legaltext__block bottom-part w-[100%] bg-[#262a40] z-[1] relative rounded-br-[16px] rounded-bl-[16px] md:rounded-bl-none">
                    <a className="rounded-br-[16px] rounded-bl-[16px] legaltext__overlay absolute -z-[1] left-0 right-0 bottom-0 top-0 text-[#FFF] bg-[#262a40]"
                      target="_blank"
                      rel="noreferrer"
                      href="https://out.casinonlineireland.site/track/click/?pid=685470&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=9&amp;action=dl-legal">
                    </a>
                    <div
                      className="legaltext__inner legal-text pointer-events-none relative z-[1] text-[#FFF] text-center flex justify-center pt-[13px] pb-[3px] px-[13px]">
                      <p className="leading-[10px]">
                        <sup className="text-[9px] leading-[13.5px] text-white" id="legal-text-content"
                          data-full-text="">18+ New customers only. Opt in, wager €10 on selected
                          slots within 7 days. Get 2x€25 Slots Bonuses for selected games and 50 Free
                          Spins on Big Bass Splash, which expire in 30 days. 40x wagering, max redeem
                          on bonuses €1,250. Scroll down for T&Cs. Gamblingcare.ie. Please gamble
                          responsibly.</sup>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="md:hidden w-full" data-skeleton="true">
                <div
                  className="legaltext__block bottom-part w-[100%] bg-[#262a40] z-[1] relative rounded-br-[16px] rounded-bl-[16px] md:rounded-bl-none">
                  <a className="rounded-br-[16px] rounded-bl-[16px] legaltext__overlay absolute -z-[1] left-0 right-0 bottom-0 top-0 text-[#FFF] bg-[#262a40]"
                    target="_blank"
                    rel="noreferrer"
                    href="https://out.casinonlineireland.site/track/click/?pid=685470&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=9&amp;action=dl-legal">
                  </a>
                  <div
                    className="legaltext__inner legal-text pointer-events-none relative z-[1] text-[#FFF] text-center flex justify-center pt-[13px] pb-[3px] px-[13px]">
                    <p className="leading-[10px]">
                      <sup className="text-[9px] leading-[13.5px] text-white" id="legal-text-content"
                        data-full-text="">18+ New customers only. Opt in, wager €10 on selected slots
                        within 7 days. Get 2x€25 Slots Bonuses for selected games and 50 Free Spins on
                        Big Bass Splash, which expire in 30 days. 40x wagering, max redeem on bonuses
                        €1,250. Scroll down for T&Cs. Gamblingcare.ie. Please gamble responsibly.</sup>
                    </p>
                  </div>
                </div>
              </div>
            </article>
            <article className="lineup-item flex relative z-[1] flex-wrap mt-[8px] rounded-2xl secondary-order"
              data-skeleton-loading="true"

              data-id="548" data-brand_id="108603" data-pid="679827" data-name="Tonybet casino"
              data-badge="false">
              <div className="ppc-list__item_logo relative rounded-tl-[16px] py-[16px] px-[18px] flex flex-col justify-center w-[40%] bg-[#1c1f33] md:w-[20%] md:rounded-bl-[16px]
    md:items-center">
                <a className="brand-name-logo-link" rel="noreferrer" target="_blank" data-skeleton="true"
                  href="https://out.casinonlineireland.site/track/click/?pid=679827&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=10&amp;action=dl-logo">
                  <img src={tonybet}
                    alt="Tonybet casino" loading="lazy" data-logo
                    className="lozad max-h-[65px] w-[180px] max-w-full block mx-auto mt-[8px]"
                    data-loaded="true" />
                </a>
                <div className="md:hidden text-center">
                  <a className="rating flex flex-col mt-[10px] items-center md:mt-0"
                    target="_blank"
                    rel="noreferrer"
                    href="https://out.casinonlineireland.site/track/click/?pid=679827&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=10&amp;action=dl-score">
                    <div className="score betting text-white font-poppins text-[32px] font-semibold md:leading-7 md:mb-[6px]"
                      data-skeleton="true">
                      8.4
                    </div>
                    <div className="score-stars brand-stars-wrapper" data-skeleton="true">
                      <ul className="star-row betting" data-default="3.5">
                        <li><i className="stars"></i></li>
                        <li><i className="stars"></i></li>
                        <li><i className="stars"></i></li>
                        <li><i className="stars"></i></li>
                        <li><i className="stars"></i></li>
                      </ul>
                    </div>
                  </a>
                </div>
              </div>
              <div
                className="ppc-list__item_info w-[60%] rounded-tr-[16px] bg-[#2f334e] text-center py-[16px] px-[9px] md:w-[80%] flex justify-center md:flex-col md:px-0 md:pb-0 md:rounded-br-[16px]">
                <div
                  className="flex flex-col md:flex-row md:pb-[16px] md:px-[32px] md:pl-[45px] justify-center md:justify-between md:items-center">
                  <div className="bonus-text-wrapper md:relative md:w-[224px]">
                    <a className="bonus-text-wrapper"
                      href="https://out.casinonlineireland.site/track/click/?pid=679827&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=10&amp;action=dl-bonus"
                      rel="noreferrer" target="_blank" title="">
                      <div className="text-center text-white text-[15px] sm:text-[18px] font-medium leading-[24px] sm:max-w-[330px] md:w-full"
                        data-skeleton="true">
                        <p>100% Up To €1050<br />
                          + 150 Free Spins</p>

                      </div>
                    </a>
                  </div>
                  <div className="hidden md:block h-full w-[1px] bg-[#1c1f33]"></div>
                  <div className="brd hidden md:relative md:block md:w-[110px]">
                    <a className="rating flex flex-col mt-[10px] items-center md:mt-0"
                      target="_blank"
                      rel="noreferrer"
                      href="https://out.casinonlineireland.site/track/click/?pid=679827&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=10&amp;action=dl-score">
                      <div className="score betting text-white font-poppins text-[32px] font-semibold md:leading-7 md:mb-[6px]"
                        data-skeleton="true">
                        8.4
                      </div>
                      <div className="score-stars brand-stars-wrapper" data-skeleton="true">
                        <ul className="star-row betting" data-default="3.5">
                          <li><i className="stars"></i></li>
                          <li><i className="stars"></i></li>
                          <li><i className="stars"></i></li>
                          <li><i className="stars"></i></li>
                          <li><i className="stars"></i></li>
                        </ul>
                      </div>
                    </a>
                  </div>
                  <div className="hidden md:block h-full w-[1px] bg-[#1c1f33]"></div>

                  <div className="mt-[12px] md:mt-0 md:relative flex flex-col items-center">
                    <a className="bonus-btn-wrapper hover:brightness-[1.15] active:brightness-[0.91] w-[160px] md:w-[168px] inline-block py-[4.5px] px-[15px] md:py-[6.5px] h-[40px] md:h-[44px] rounded-[10px]"
                      href="https://out.casinonlineireland.site/track/click/?pid=679827&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=10&amp;action=dl-btn"
                      rel="noreferrer" target="_blank" title="" data-skeleton="true">
                      <span
                        className="bonus-button font-poppins text-white font-extrabold uppercase text-[18px] inline-block relative leading-8">
                        Get Bonus
                      </span>
                    </a>
                    <a className="visit-site !text-[#63BCFF] hover:!text-[#A5D8FF] text-[14px] relative md:inline-block mt-[16px] font-poppins"
                      href="https://out.casinonlineireland.site/track/click/?pid=679827&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=10&amp;action=dl-textlink"
                      rel="noreferrer" target="_blank" data-skeleton="true" title="Tonybet casino ">
                      Visit Site
                    </a>
                  </div>
                </div>
                <div className="hidden md:block" data-skeleton="true">
                  <div
                    className="legaltext__block bottom-part w-[100%] bg-[#262a40] z-[1] relative rounded-br-[16px] rounded-bl-[16px] md:rounded-bl-none">
                    <a className="rounded-br-[16px] rounded-bl-[16px] legaltext__overlay absolute -z-[1] left-0 right-0 bottom-0 top-0 text-[#FFF] bg-[#262a40]"
                      target="_blank"
                      rel="noreferrer"
                      href="https://out.casinonlineireland.site/track/click/?pid=679827&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=10&amp;action=dl-legal">
                    </a>
                    <div
                      className="legaltext__inner legal-text pointer-events-none relative z-[1] text-[#FFF] text-center flex justify-center pt-[13px] pb-[3px] px-[13px]">
                      <p className="leading-[10px]">
                        <sup className="text-[9px] leading-[13.5px] text-white" id="legal-text-content"
                          data-full-text="">New Customers Only. 18+.Wagering requirements and T&C's
                          Apply</sup>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="md:hidden w-full" data-skeleton="true">
                <div
                  className="legaltext__block bottom-part w-[100%] bg-[#262a40] z-[1] relative rounded-br-[16px] rounded-bl-[16px] md:rounded-bl-none">
                  <a className="rounded-br-[16px] rounded-bl-[16px] legaltext__overlay absolute -z-[1] left-0 right-0 bottom-0 top-0 text-[#FFF] bg-[#262a40]"
                    target="_blank"
                    rel="noreferrer"
                    href="https://out.casinonlineireland.site/track/click/?pid=679827&amp;list_id=1751&amp;page=/&amp;dynamic_list=PPC - Ireland - Main&amp;internal=true&amp;position=10&amp;action=dl-legal">
                  </a>
                  <div
                    className="legaltext__inner legal-text pointer-events-none relative z-[1] text-[#FFF] text-center flex justify-center pt-[13px] pb-[3px] px-[13px]">
                    <p className="leading-[10px]">
                      <sup className="text-[9px] leading-[13.5px] text-white" id="legal-text-content"
                        data-full-text="">New Customers Only. 18+.Wagering requirements and T&C's
                        Apply</sup>
                    </p>
                  </div>
                </div>
              </div>
            </article>
          </div>

          <div className="flex-[1_0] min-w-0 !pb-0" id="cross-banners">
            <div className="cross-banner-container">
              <h2
                className="font-[700] sm:text-[28px] text-[22px] relative p-0 tracking-[0.96px] md:tracking-[1.6px] w-full text-white text-left md:m-0 leading-[26px] sm:leading-[32px] pt-[30px] pb-[30px]">
                Top Live Casino Sites 2026
              </h2>
              <div id="cross_banner_1"
                className="flex flex-col gap-[24px] cross-banner lineup-contaner shadow-[0_0_14px_7px_black] bg-black"
                data-list-id="1927">
                <article
                  data-skeleton-loading="true"
                  className="lineup-item flex relative z-[1] flex-wrap mt-[8px] rounded-2xl primary-order"
                  data-id="371" data-brand_id="112983" data-pid="683505" data-name="Boyle" data-badge="false">
                  <div className="ppc-list__item_logo relative rounded-tl-[16px] py-[16px] px-[18px] flex flex-col justify-center w-[40%] bg-[#1c1f33] md:w-[20%] md:rounded-bl-[16px]
    md:items-center">
                    <a className="brand-name-logo-link" rel="noreferrer" target="_blank" data-skeleton="true"
                      href="https://out.casinonlineireland.site/track/click/?pid=683505&amp;list_id=1927&amp;page=/&amp;dynamic_list=Cross - Casino IE - Bing&amp;internal=true&amp;position=1&amp;action=dl-logo">
                      <img src={boylecasino}
                        alt="Boyle" loading="lazy" data-logo
                        className="lozad max-h-[65px] w-[180px] max-w-full block mx-auto mt-[8px]"
                        data-loaded="true" />
                    </a>
                    <div className="md:hidden text-center">
                      <a className="rating flex flex-col mt-[10px] items-center md:mt-0"
                        target="_blank"
                        rel="noreferrer"
                        href="https://out.casinonlineireland.site/track/click/?pid=683505&amp;list_id=1927&amp;page=/&amp;dynamic_list=Cross - Casino IE - Bing&amp;internal=true&amp;position=1&amp;action=dl-score">
                        <div className="score betting text-white font-poppins text-[32px] font-semibold md:leading-7 md:mb-[6px]"
                          data-skeleton="true">
                          9.9
                        </div>
                        <div className="score-stars brand-stars-wrapper" data-skeleton="true">
                          <ul className="star-row betting" data-default="5">
                            <li><i className="stars"></i></li>
                            <li><i className="stars"></i></li>
                            <li><i className="stars"></i></li>
                            <li><i className="stars"></i></li>
                            <li><i className="stars"></i></li>
                          </ul>
                        </div>
                      </a>
                    </div>
                  </div>
                  <div
                    className="ppc-list__item_info w-[60%] rounded-tr-[16px] bg-[#2f334e] text-center py-[16px] px-[9px] md:w-[80%] flex justify-center md:flex-col md:px-0 md:pb-0 md:rounded-br-[16px]">
                    <div
                      className="flex flex-col md:flex-row md:pb-[16px] md:px-[32px] md:pl-[45px] justify-center md:justify-between md:items-center">
                      <div className="bonus-text-wrapper md:relative md:w-[224px]">
                        <a className="bonus-text-wrapper"
                          href="https://out.casinonlineireland.site/track/click/?pid=683505&amp;list_id=1927&amp;page=/&amp;dynamic_list=Cross - Casino IE - Bing&amp;internal=true&amp;position=1&amp;action=dl-bonus"
                          rel="noreferrer" target="_blank" title="">
                          <div className="text-center text-white text-[15px] sm:text-[18px] font-medium leading-[24px] sm:max-w-[330px] md:w-full"
                            data-skeleton="true">
                            <p style={{ textAlign: 'center' }}>Get €50 Casino Bonus</p>

                          </div>
                        </a>
                      </div>
                      <div className="hidden md:block h-full w-[1px] bg-[#1c1f33]"></div>
                      <div className="brd hidden md:relative md:block md:w-[110px]">
                        <a className="rating flex flex-col mt-[10px] items-center md:mt-0"
                          target="_blank"
                          rel="noreferrer"
                          href="https://out.casinonlineireland.site/track/click/?pid=683505&amp;list_id=1927&amp;page=/&amp;dynamic_list=Cross - Casino IE - Bing&amp;internal=true&amp;position=1&amp;action=dl-score">
                          <div className="score betting text-white font-poppins text-[32px] font-semibold md:leading-7 md:mb-[6px]"
                            data-skeleton="true">
                            9.9
                          </div>
                          <div className="score-stars brand-stars-wrapper" data-skeleton="true">
                            <ul className="star-row betting" data-default="5">
                              <li><i className="stars"></i></li>
                              <li><i className="stars"></i></li>
                              <li><i className="stars"></i></li>
                              <li><i className="stars"></i></li>
                              <li><i className="stars"></i></li>
                            </ul>
                          </div>
                        </a>
                      </div>
                      <div className="hidden md:block h-full w-[1px] bg-[#1c1f33]"></div>

                      <div className="mt-[12px] md:mt-0 md:relative flex flex-col items-center">
                        <a className="bonus-btn-wrapper hover:brightness-[1.15] active:brightness-[0.91] w-[160px] md:w-[168px] inline-block py-[4.5px] px-[15px] md:py-[6.5px] h-[40px] md:h-[44px] rounded-[10px]"
                          href="https://out.casinonlineireland.site/track/click/?pid=683505&amp;list_id=1927&amp;page=/&amp;dynamic_list=Cross - Casino IE - Bing&amp;internal=true&amp;position=1&amp;action=dl-btn"
                          rel="noreferrer" target="_blank" title="" data-skeleton="true">
                          <span
                            className="bonus-button font-poppins text-white font-extrabold uppercase text-[18px] inline-block relative leading-8">
                            Get Bonus
                          </span>
                        </a>
                        <a className="visit-site !text-[#63BCFF] hover:!text-[#A5D8FF] text-[14px] relative md:inline-block mt-[16px] font-poppins"
                          href="https://out.casinonlineireland.site/track/click/?pid=683505&amp;list_id=1927&amp;page=/&amp;dynamic_list=Cross - Casino IE - Bing&amp;internal=true&amp;position=1&amp;action=dl-textlink"
                          rel="noreferrer" target="_blank" data-skeleton="true" title="Boyle">
                          Visit Site
                        </a>
                      </div>
                    </div>
                    <div className="hidden md:block" data-skeleton="true">
                      <div
                        className="legaltext__block bottom-part w-[100%] bg-[#262a40] z-[1] relative rounded-br-[16px] rounded-bl-[16px] md:rounded-bl-none">
                        <a className="rounded-br-[16px] rounded-bl-[16px] legaltext__overlay absolute -z-[1] left-0 right-0 bottom-0 top-0 text-[#FFF] bg-[#262a40]"
                          target="_blank"
                          rel="noreferrer"
                          href="https://out.casinonlineireland.site/track/click/?pid=683505&amp;list_id=1927&amp;page=/&amp;dynamic_list=Cross - Casino IE - Bing&amp;internal=true&amp;position=1&amp;action=dl-legal">
                        </a>
                        <div
                          className="legaltext__inner legal-text pointer-events-none relative z-[1] text-[#FFF] text-center flex justify-center pt-[13px] pb-[3px] px-[13px]">
                          <p className="leading-[10px]">
                            <sup className="text-[9px] leading-[13.5px] text-white"
                              id="legal-text-content" data-full-text="">18+. Opt in.
                              Acc/Game/Payment restrictions apply. B10G50: Exp. 12.01.26. New
                              UK/ROI gaming players. Excl. other Casino welcome offers. Min. cash
                              wag. £/€10(cumulative) within 48hrs. 168 hrs to accept & use Bonus.
                              Max. redeem. £/€500. 40x wag. Cash balance used until wag. req.
                              complete. once per player. Snow Run: Ends 26.12.25. Once daily. Free
                              Spin (FS) value £/€0.10. Offer accepted by 23:59 same day. 24
                              hrs/play FS. Accept free-to-play prize to enter the draws. 1
                              prize/player/draw, 5 draws total. Min £/€10 dep & stake per draw. 1
                              entry per €/£10 staked. T&Cs Apply</sup>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="md:hidden w-full" data-skeleton="true">
                    <div
                      className="legaltext__block bottom-part w-[100%] bg-[#262a40] z-[1] relative rounded-br-[16px] rounded-bl-[16px] md:rounded-bl-none">
                      <a className="rounded-br-[16px] rounded-bl-[16px] legaltext__overlay absolute -z-[1] left-0 right-0 bottom-0 top-0 text-[#FFF] bg-[#262a40]"
                        target="_blank"
                        rel="noreferrer"
                        href="https://out.casinonlineireland.site/track/click/?pid=683505&amp;list_id=1927&amp;page=/&amp;dynamic_list=Cross - Casino IE - Bing&amp;internal=true&amp;position=1&amp;action=dl-legal">
                      </a>
                      <div
                        className="legaltext__inner legal-text pointer-events-none relative z-[1] text-[#FFF] text-center flex justify-center pt-[13px] pb-[3px] px-[13px]">
                        <p className="leading-[10px]">
                          <sup className="text-[9px] leading-[13.5px] text-white" id="legal-text-content"
                            data-full-text="">18+. Opt in. Acc/Game/Payment restrictions apply.
                            B10G50: Exp. 12.01.26. New UK/ROI gaming players. Excl. other Casino
                            welcome offers. Min. cash wag. £/€10(cumulative) within 48hrs. 168 hrs
                            to accept & use Bonus. Max. redeem. £/€500. 40x wag. Cash balance used
                            until wag. req. complete. once per player. Snow Run: Ends 26.12.25. Once
                            daily. Free Spin (FS) value £/€0.10. Offer accepted by 23:59 same day.
                            24 hrs/play FS. Accept free-to-play prize to enter the draws. 1
                            prize/player/draw, 5 draws total. Min £/€10 dep & stake per draw. 1
                            entry per €/£10 staked. T&Cs Apply</sup>
                        </p>
                      </div>
                    </div>
                  </div>
                </article>
                <article
                  data-skeleton-loading="true"
                  className="lineup-item flex relative z-[1] flex-wrap mt-[8px] rounded-2xl secondary-order"
                  data-id="599" data-brand_id="113688" data-pid="684657" data-name="Coral" data-badge="false">
                  <div className="ppc-list__item_logo relative rounded-tl-[16px] py-[16px] px-[18px] flex flex-col justify-center w-[40%] bg-[#1c1f33] md:w-[20%] md:rounded-bl-[16px]
    md:items-center">
                    <a className="brand-name-logo-link" rel="noreferrer" target="_blank" data-skeleton="true"
                      href="https://out.casinonlineireland.site/track/click/?pid=684657&amp;list_id=1927&amp;page=/&amp;dynamic_list=Cross - Casino IE - Bing&amp;internal=true&amp;position=2&amp;action=dl-logo">
                      <img src={coral}
                        alt="Coral" loading="lazy" data-logo
                        className="lozad max-h-[65px] w-[180px] max-w-full block mx-auto mt-[8px]"
                        data-loaded="true" />
                    </a>
                    <div className="md:hidden text-center">
                      <a className="rating flex flex-col mt-[10px] items-center md:mt-0"
                        target="_blank"
                        rel="noreferrer"
                        href="https://out.casinonlineireland.site/track/click/?pid=684657&amp;list_id=1927&amp;page=/&amp;dynamic_list=Cross - Casino IE - Bing&amp;internal=true&amp;position=2&amp;action=dl-score">
                        <div className="score betting text-white font-poppins text-[32px] font-semibold md:leading-7 md:mb-[6px]"
                          data-skeleton="true">
                          9.8
                        </div>
                        <div className="score-stars brand-stars-wrapper" data-skeleton="true">
                          <ul className="star-row betting" data-default="5">
                            <li><i className="stars"></i></li>
                            <li><i className="stars"></i></li>
                            <li><i className="stars"></i></li>
                            <li><i className="stars"></i></li>
                            <li><i className="stars"></i></li>
                          </ul>
                        </div>
                      </a>
                    </div>
                  </div>
                  <div
                    className="ppc-list__item_info w-[60%] rounded-tr-[16px] bg-[#2f334e] text-center py-[16px] px-[9px] md:w-[80%] flex justify-center md:flex-col md:px-0 md:pb-0 md:rounded-br-[16px]">
                    <div
                      className="flex flex-col md:flex-row md:pb-[16px] md:px-[32px] md:pl-[45px] justify-center md:justify-between md:items-center">
                      <div className="bonus-text-wrapper md:relative md:w-[224px]">
                        <a className="bonus-text-wrapper"
                          href="https://out.casinonlineireland.site/track/click/?pid=684657&amp;list_id=1927&amp;page=/&amp;dynamic_list=Cross - Casino IE - Bing&amp;internal=true&amp;position=2&amp;action=dl-bonus"
                          rel="noreferrer" target="_blank" title="">
                          <div className="text-center text-white text-[15px] sm:text-[18px] font-medium leading-[24px] sm:max-w-[330px] md:w-full"
                            data-skeleton="true">
                            <p>Play €10 Get 100 Free Spins</p>

                          </div>
                        </a>
                      </div>
                      <div className="hidden md:block h-full w-[1px] bg-[#1c1f33]"></div>
                      <div className="brd hidden md:relative md:block md:w-[110px]">
                        <a className="rating flex flex-col mt-[10px] items-center md:mt-0"
                          target="_blank"
                          rel="noreferrer"
                          href="https://out.casinonlineireland.site/track/click/?pid=684657&amp;list_id=1927&amp;page=/&amp;dynamic_list=Cross - Casino IE - Bing&amp;internal=true&amp;position=2&amp;action=dl-score">
                          <div className="score betting text-white font-poppins text-[32px] font-semibold md:leading-7 md:mb-[6px]"
                            data-skeleton="true">
                            9.8
                          </div>
                          <div className="score-stars brand-stars-wrapper" data-skeleton="true">
                            <ul className="star-row betting" data-default="5">
                              <li><i className="stars"></i></li>
                              <li><i className="stars"></i></li>
                              <li><i className="stars"></i></li>
                              <li><i className="stars"></i></li>
                              <li><i className="stars"></i></li>
                            </ul>
                          </div>
                        </a>
                      </div>
                      <div className="hidden md:block h-full w-[1px] bg-[#1c1f33]"></div>

                      <div className="mt-[12px] md:mt-0 md:relative flex flex-col items-center">
                        <a className="bonus-btn-wrapper hover:brightness-[1.15] active:brightness-[0.91] w-[160px] md:w-[168px] inline-block py-[4.5px] px-[15px] md:py-[6.5px] h-[40px] md:h-[44px] rounded-[10px]"
                          href="https://out.casinonlineireland.site/track/click/?pid=684657&amp;list_id=1927&amp;page=/&amp;dynamic_list=Cross - Casino IE - Bing&amp;internal=true&amp;position=2&amp;action=dl-btn"
                          rel="noreferrer" target="_blank" title="" data-skeleton="true">
                          <span
                            className="bonus-button font-poppins text-white font-extrabold uppercase text-[18px] inline-block relative leading-8">
                            Get Bonus
                          </span>
                        </a>
                        <a className="visit-site !text-[#63BCFF] hover:!text-[#A5D8FF] text-[14px] relative md:inline-block mt-[16px] font-poppins"
                          href="https://out.casinonlineireland.site/track/click/?pid=684657&amp;list_id=1927&amp;page=/&amp;dynamic_list=Cross - Casino IE - Bing&amp;internal=true&amp;position=2&amp;action=dl-textlink"
                          rel="noreferrer" target="_blank" data-skeleton="true" title="Coral">
                          Visit Site
                        </a>
                      </div>
                    </div>
                    <div className="hidden md:block" data-skeleton="true">
                      <div
                        className="legaltext__block bottom-part w-[100%] bg-[#262a40] z-[1] relative rounded-br-[16px] rounded-bl-[16px] md:rounded-bl-none">
                        <a className="rounded-br-[16px] rounded-bl-[16px] legaltext__overlay absolute -z-[1] left-0 right-0 bottom-0 top-0 text-[#FFF] bg-[#262a40]"
                          target="_blank"
                          rel="noreferrer"
                          href="https://out.casinonlineireland.site/track/click/?pid=684657&amp;list_id=1927&amp;page=/&amp;dynamic_list=Cross - Casino IE - Bing&amp;internal=true&amp;position=2&amp;action=dl-legal">
                        </a>
                        <div
                          className="legaltext__inner legal-text pointer-events-none relative z-[1] text-[#FFF] text-center flex justify-center pt-[13px] pb-[3px] px-[13px]">
                          <p className="leading-[10px]">
                            <sup className="text-[9px] leading-[13.5px] text-white"
                              id="legal-text-content" data-full-text="">18+. New Casino players
                              only. Deposit (certain types excluded) and Bet €10+ on Slots games
                              to get 100 Free Spins (selected games, value €0.10 each, 48 hrs to
                              accept, valid for 7 days). Restrictions and T&Cs apply.</sup>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="md:hidden w-full" data-skeleton="true">
                    <div
                      className="legaltext__block bottom-part w-[100%] bg-[#262a40] z-[1] relative rounded-br-[16px] rounded-bl-[16px] md:rounded-bl-none">
                      <a className="rounded-br-[16px] rounded-bl-[16px] legaltext__overlay absolute -z-[1] left-0 right-0 bottom-0 top-0 text-[#FFF] bg-[#262a40]"
                        target="_blank"
                        rel="noreferrer"
                        href="https://out.casinonlineireland.site/track/click/?pid=684657&amp;list_id=1927&amp;page=/&amp;dynamic_list=Cross - Casino IE - Bing&amp;internal=true&amp;position=2&amp;action=dl-legal">
                      </a>
                      <div
                        className="legaltext__inner legal-text pointer-events-none relative z-[1] text-[#FFF] text-center flex justify-center pt-[13px] pb-[3px] px-[13px]">
                        <p className="leading-[10px]">
                          <sup className="text-[9px] leading-[13.5px] text-white" id="legal-text-content"
                            data-full-text="">18+. New Casino players only. Deposit (certain types
                            excluded) and Bet €10+ on Slots games to get 100 Free Spins (selected
                            games, value €0.10 each, 48 hrs to accept, valid for 7 days).
                            Restrictions and T&Cs apply.</sup>
                        </p>
                      </div>
                    </div>
                  </div>
                </article>
                <article
                  data-skeleton-loading="true"
                  className="lineup-item flex relative z-[1] flex-wrap mt-[8px] rounded-2xl secondary-order"
                  data-id="913" data-brand_id="108621" data-pid="679845" data-name="Lottoland Casino"
                  data-badge="false">
                  <div className="ppc-list__item_logo relative rounded-tl-[16px] py-[16px] px-[18px] flex flex-col justify-center w-[40%] bg-[#1c1f33] md:w-[20%] md:rounded-bl-[16px]
    md:items-center">
                    <a className="brand-name-logo-link" rel="noreferrer" target="_blank" data-skeleton="true"
                      href="https://out.casinonlineireland.site/track/click/?pid=679845&amp;list_id=1927&amp;page=/&amp;dynamic_list=Cross - Casino IE - Bing&amp;internal=true&amp;position=3&amp;action=dl-logo">
                      <img src={lottoland}
                        alt="Lottoland Casino" loading="lazy" data-logo
                        className="lozad max-h-[65px] w-[180px] max-w-full block mx-auto mt-[8px]"
                        data-loaded="true" />
                    </a>
                    <div className="md:hidden text-center">
                      <a className="rating flex flex-col mt-[10px] items-center md:mt-0"
                        target="_blank"
                        rel="noreferrer"
                        href="https://out.casinonlineireland.site/track/click/?pid=679845&amp;list_id=1927&amp;page=/&amp;dynamic_list=Cross - Casino IE - Bing&amp;internal=true&amp;position=3&amp;action=dl-score">
                        <div className="score betting text-white font-poppins text-[32px] font-semibold md:leading-7 md:mb-[6px]"
                          data-skeleton="true">
                          9.7
                        </div>
                        <div className="score-stars brand-stars-wrapper" data-skeleton="true">
                          <ul className="star-row betting" data-default="5">
                            <li><i className="stars"></i></li>
                            <li><i className="stars"></i></li>
                            <li><i className="stars"></i></li>
                            <li><i className="stars"></i></li>
                            <li><i className="stars"></i></li>
                          </ul>
                        </div>
                      </a>
                    </div>
                  </div>
                  <div
                    className="ppc-list__item_info w-[60%] rounded-tr-[16px] bg-[#2f334e] text-center py-[16px] px-[9px] md:w-[80%] flex justify-center md:flex-col md:px-0 md:pb-0 md:rounded-br-[16px]">
                    <div
                      className="flex flex-col md:flex-row md:pb-[16px] md:px-[32px] md:pl-[45px] justify-center md:justify-between md:items-center">
                      <div className="bonus-text-wrapper md:relative md:w-[224px]">
                        <a className="bonus-text-wrapper"
                          href="https://out.casinonlineireland.site/track/click/?pid=679845&amp;list_id=1927&amp;page=/&amp;dynamic_list=Cross - Casino IE - Bing&amp;internal=true&amp;position=3&amp;action=dl-bonus"
                          rel="noreferrer" target="_blank" title="">
                          <div className="text-center text-white text-[15px] sm:text-[18px] font-medium leading-[24px] sm:max-w-[330px] md:w-full"
                            data-skeleton="true">
                            <p>Stake €20<br />
                              Get 100 Free Spins</p>

                          </div>
                        </a>
                      </div>
                      <div className="hidden md:block h-full w-[1px] bg-[#1c1f33]"></div>
                      <div className="brd hidden md:relative md:block md:w-[110px]">
                        <a className="rating flex flex-col mt-[10px] items-center md:mt-0"
                          target="_blank"
                          rel="noreferrer"
                          href="https://out.casinonlineireland.site/track/click/?pid=679845&amp;list_id=1927&amp;page=/&amp;dynamic_list=Cross - Casino IE - Bing&amp;internal=true&amp;position=3&amp;action=dl-score">
                          <div className="score betting text-white font-poppins text-[32px] font-semibold md:leading-7 md:mb-[6px]"
                            data-skeleton="true">
                            9.7
                          </div>
                          <div className="score-stars brand-stars-wrapper" data-skeleton="true">
                            <ul className="star-row betting" data-default="5">
                              <li><i className="stars"></i></li>
                              <li><i className="stars"></i></li>
                              <li><i className="stars"></i></li>
                              <li><i className="stars"></i></li>
                              <li><i className="stars"></i></li>
                            </ul>
                          </div>
                        </a>
                      </div>
                      <div className="hidden md:block h-full w-[1px] bg-[#1c1f33]"></div>

                      <div className="mt-[12px] md:mt-0 md:relative flex flex-col items-center">
                        <a className="bonus-btn-wrapper hover:brightness-[1.15] active:brightness-[0.91] w-[160px] md:w-[168px] inline-block py-[4.5px] px-[15px] md:py-[6.5px] h-[40px] md:h-[44px] rounded-[10px]"
                          href="https://out.casinonlineireland.site/track/click/?pid=679845&amp;list_id=1927&amp;page=/&amp;dynamic_list=Cross - Casino IE - Bing&amp;internal=true&amp;position=3&amp;action=dl-btn"
                          rel="noreferrer" target="_blank" title="" data-skeleton="true">
                          <span
                            className="bonus-button font-poppins text-white font-extrabold uppercase text-[18px] inline-block relative leading-8">
                            Get Bonus
                          </span>
                        </a>
                        <a className="visit-site !text-[#63BCFF] hover:!text-[#A5D8FF] text-[14px] relative md:inline-block mt-[16px] font-poppins"
                          href="https://out.casinonlineireland.site/track/click/?pid=679845&amp;list_id=1927&amp;page=/&amp;dynamic_list=Cross - Casino IE - Bing&amp;internal=true&amp;position=3&amp;action=dl-textlink"
                          rel="noreferrer" target="_blank" data-skeleton="true"
                          title="Lottoland Casino">
                          Visit Site
                        </a>
                      </div>
                    </div>
                    <div className="hidden md:block" data-skeleton="true">
                      <div
                        className="legaltext__block bottom-part w-[100%] bg-[#262a40] z-[1] relative rounded-br-[16px] rounded-bl-[16px] md:rounded-bl-none">
                        <a className="rounded-br-[16px] rounded-bl-[16px] legaltext__overlay absolute -z-[1] left-0 right-0 bottom-0 top-0 text-[#FFF] bg-[#262a40]"
                          target="_blank"
                          rel="noreferrer"
                          href="https://out.casinonlineireland.site/track/click/?pid=679845&amp;list_id=1927&amp;page=/&amp;dynamic_list=Cross - Casino IE - Bing&amp;internal=true&amp;position=3&amp;action=dl-legal">
                        </a>
                        <div
                          className="legaltext__inner legal-text pointer-events-none relative z-[1] text-[#FFF] text-center flex justify-center pt-[13px] pb-[3px] px-[13px]">
                          <p className="leading-[10px]">
                            <sup className="text-[9px] leading-[13.5px] text-white"
                              id="legal-text-content" data-full-text="">18+. New players only.
                              Deposit directly via the promotion page & stake €20 on Big Bass
                              Bonanza to get 100 Free spins on it. 30 day bonus expiry. Ends
                              14/02/26. Full T&Cs below.</sup>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="md:hidden w-full" data-skeleton="true">
                    <div
                      className="legaltext__block bottom-part w-[100%] bg-[#262a40] z-[1] relative rounded-br-[16px] rounded-bl-[16px] md:rounded-bl-none">
                      <a className="rounded-br-[16px] rounded-bl-[16px] legaltext__overlay absolute -z-[1] left-0 right-0 bottom-0 top-0 text-[#FFF] bg-[#262a40]"
                        target="_blank"
                        rel="noreferrer"
                        href="https://out.casinonlineireland.site/track/click/?pid=679845&amp;list_id=1927&amp;page=/&amp;dynamic_list=Cross - Casino IE - Bing&amp;internal=true&amp;position=3&amp;action=dl-legal">
                      </a>
                      <div
                        className="legaltext__inner legal-text pointer-events-none relative z-[1] text-[#FFF] text-center flex justify-center pt-[13px] pb-[3px] px-[13px]">
                        <p className="leading-[10px]">
                          <sup className="text-[9px] leading-[13.5px] text-white" id="legal-text-content"
                            data-full-text="">18+. New players only. Deposit directly via the
                            promotion page & stake €20 on Big Bass Bonanza to get 100 Free spins on
                            it. 30 day bonus expiry. Ends 14/02/26. Full T&Cs below.</sup>
                        </p>
                      </div>
                    </div>
                  </div>
                </article>
              </div>
            </div>
          </div>
          <div
            className="content lineup-article-content bg-[#1C1F33] rounded-[8px] sm:p-[50px] p-[32px_16px] sm:m-0 !mt-[30px] text-[15px] leading-[28px] md:leading-[30px]">
            <h2>Everything You Need To Know About Online Casino Sites</h2>
            <p>Here at Casinonlineireland we keep our finger on the pulse of the online casino world to bring you
              ratings of the most recommended online casinos in Ireland. Our unbiased verdicts are based on game
              selection, software, reputation, and bonus offers. Simply check the rankings and updated bonuses ,
              claim your exclusive bonus, and start playing today!</p>
            <p>Since the first online casino opened 23 years ago, online gaming has become a booming business. There
              are hundreds of online casino sites offering an array of games from Online Slots to Roulette and
              Blackjack. The sheer, ever-growing, number of online casinos can be overwhelming for new users.</p>
            <p>So, before you get started, take the time to look over our casino site rankings, updated Bonuses and
              use our comparison tool to find the exact features you need.</p>
            <h3><strong><em>Land-Based Casinos vs. Online Casinos</em></strong></h3>
            <p>When you go to a land-based casino you are usually overstimulated by all the bright lights, music and
              overall buzz. It&#8217;s that kind of excitement which can&#8217;t be replaced easily. Most online
              casinos aim to replicate this sensation, and many of them actually succeed.</p>
            <p>At a land-based casino you may need to wait your turn to play a table game while other players place
              their bets or remove their winnings from previous hands. You might also get distracted by your
              fellow players. With online casinos the whole experience is much smoother. Simply choose the game
              you want to play and jump straight into action. Most games are played at your pace so there’s no
              waiting for someone else to bet, nor having someone else rush you to make your move.</p>
            <p>In a land-based casino you may find it hard to locate your specific table game, or the minimum bet
              might be too high. Online casinos give you hundreds of game variations at all stake levels, making
              it much easier to find exactly the one you want to play.</p>
            <h3><span style={{ color: '#ffffff' }}>Recommended Online Casino Sites</span></h3>
            <p>These are some of the most recommended Online Casino Sites on the market:</p>
            <div id="seo-list" className="seo-list">
              <ul className="seo-list-widget">
                <li>
                  <a target="_blank"
                  rel="noreferrer"
                    href="https://out.casinonlineireland.site/track/click/?pid=685473&amp;list_id=1751&amp;action=lp-article-list&amp;page=/&amp;internal=true&amp;position=1&amp;dynamiclist_name=PPC - Ireland - Main">Midnite</a>
                </li>
                <li>
                  <a target="_blank"
                  rel="noreferrer"
                    href=" https://out.casinonlineireland.site/track/click/?pid=679932&amp;list_id=1751&amp;action=lp-article-list&amp;page=/&amp;internal=true&amp;position=2&amp;dynamiclist_name=PPC - Ireland - Main">betiton</a>
                </li>
                <li>
                  <a target="_blank"
                  rel="noreferrer"
                    href="https://out.casinonlineireland.site/track/click/?pid=685527&amp;list_id=1751&amp;action=lp-article-list&amp;page=/&amp;internal=true&amp;position=3&amp;dynamiclist_name=PPC - Ireland - Main">Betvictor
                  </a>
                </li>
              </ul>
            </div>
            <h3><strong><em>Casino Games Offered by Gambling Sites:</em></strong></h3>
            <p><strong><em><br />
            </em></strong>One huge advantage of playing at an online casino is the virtually unlimited space
              they have to offer every kind of game, at every possible stake. Online casinos have a huge selection
              of slot games, some similar to those you have seen in real casinos, whilst others take full
              advantage of the technology at hand and provide a smooth, enjoyable experience while utilizing
              advanced graphics, features and sound effects.</p>
            <p>In addition to a complete range of online slots, you can play familiar favourites like blackjack,
              baccarat, craps, roulette, keno and video poker games.</p>
            <h3><strong><em>Live Casino – The Best Of Both Worlds?</em></strong></h3>
            <p>If want to avoid the distractions of a land-based casino but also don’t feel like playing blackjack
              online like a computer game, then you might find the live blackjack and live roulette tables offered
              by many casino sites the perfect balance.</p>
            <p>With live casinos you really feel part of the action. They do away with the slick computer graphics
              and replace them with live videos feed of a real dealer dealing you cards, or spinning a real
              roulette wheel. The whole experience and thrill is much more akin to that you&#8217;d feel at a real
              land-based casino, truly giving you the best of both worlds.</p>
            <h3><strong><em>How to Play at an Internet Casino</em></strong></h3>
            <p>Most online gaming sites offer their own software which can be easily downloaded, giving you access
              to their virtual casino. The software is free and usually allows you to test the games with virtual
              money. You also have the option to play directly from your browser with Instant Play, which is
              offered by almost all sites. This is a real advantage if you want to have a quick session on a
              computer that’s not your own. Similarly, no self-respecting casino comes without companion apps for
              mobile phones and tablets, which means you’ll never be stuck for a way to play, wherever you happen
              to be!</p>
            <h3><strong><em>Casino Bonuses – Starting Off Right</em></strong></h3>
            <p>The intense competition that exists between the hundreds of online casinos has led to the rise of the
              casino bonus as an easy way to attract new players. These promotional offers can be worth hundreds
              of pounds, so they’re a great way to boost your bankroll. It’s important to read all of the terms
              and conditions associated with your welcome bonus, though. Most casinos require you to make a
              deposit with your own money before you get access to your bonus, and you usually need to meet a
              wagering requirement before you’ll be able to withdraw any winnings.</p>
            <h3><strong><em>Is Online Gaming Legal?</em></strong></h3>
            <p>Not every country allows online gaming, although actual prosecution of players is rare since they
              play from their home. Online casino websites must operate from countries that allow online gaming
              such as Australia, New Zealand, South Korea, Denmark, Finland, France, the UK and Germany.
              Altogether there are about 70 countries that allow online gaming. Each online casino has a set of
              rules and restrictions which must be followed. There are requirements as to age and locale. If it is
              discovered that online gaming is illegal where you live you may have to forfeit any winnings, so be
              careful when playing games at online casino sites.</p>
            <p><strong><em>All of the brands we feature on Casinonlineireland offer a great mixture of game
              selection, good software, and exceptional bonuses. Pick your favourite and start playing
              today.</em></strong></p>
            <p>&nbsp;</p>
            <p><a href="https://gamblingcare.ie/" target="_blank" rel="noopener noreferrer"><img decoding="async"
              className="alignnone  wp-image-888"
              src={GamblingCare}
              alt="GamblingCare logo" width="215" height="28"
              sizes="(max-width: 215px) 100vw, 215px" /></a></p>

          </div>
        </main>
      </main>
    </div>
  );
};

export default HomePage;


